// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../../node_modules/slick-carousel/slick/slick.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../../node_modules/slick-carousel/slick/slick-theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main_icons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 25px;
}
.main_icons .main_buying,
.main_icons .buying_icon,
.main_icons .favorites {
  position: relative;
}
.main_icons .main_user {
  cursor: pointer;
}
.main_icons .buying_count,
.main_icons .favorite_count {
  font-size: 16px;
  color: #fff;
  position: absolute;
  bottom: 14px;
  left: 15px;
  z-index: 1;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  background-color: #000000;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: Roboto, sans-serif;
  font-size: 14px;
}

html {
  height: 100%;
}

header {
  height: 155px;
  padding: 18px 40px 18px 0;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #C0C0C0;
}
header .logo_Items {
  display: flex;
  align-items: center;
  text-decoration: none;
  text-transform: uppercase;
  line-height: 24px;
  font-size: 18px;
  letter-spacing: 0.54px;
  color: #070707;
  cursor: pointer;
}
header .logo_Items .logo_text {
  font-size: 24px;
  line-height: 28px;
  font-weight: 300;
}
@media (max-width: 600px) {
  header .logo_Items .logo_text {
    display: none;
  }
}
header .logo_Items .logo {
  width: 161px;
  max-width: 100%;
}
header .header_menu {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  height: 90px;
}
@media (max-width: 769px) {
  header .header_menu {
    justify-content: space-around;
  }
}
header .header_menu .header_languages button {
  font-size: 14px;
  font-weight: 700;
  padding: 0 clamp(0.3125rem, 0.2232rem + 0.4464vw, 0.625rem);
  text-decoration: none;
  text-transform: uppercase;
  cursor: pointer;
  color: #868181;
  border-color: transparent;
  background-color: transparent;
}
header .header_menu .header_languages button:nth-child(2) {
  border-right: 3px solid #B0D404;
  border-left: 3px solid #B0D404;
}
header .header_menu .header_languages .selected {
  color: #000;
}
header .header_menu .main_menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: clamp(3.125rem, -8.1646rem + 18.0995vw, 8.125rem);
  font-weight: 700;
}
@media (max-width: 998px) {
  header .header_menu .main_menu {
    gap: 30px;
  }
}
header .header_menu main {
  display: flex;
  gap: 30px;
}
@media (max-width: 998px) {
  header .header_menu main {
    display: none;
  }
}
header .header_menu main a {
  color: #555;
  transition: all 0.3s ease-in-out;
  position: relative;
  text-transform: capitalize;
  font-size: 16px;
  letter-spacing: 1px;
}
header .header_menu main a.link {
  color: #555;
}
header .header_menu main a.active {
  color: #F56E91;
}
header .header_menu main a.hover {
  color: #F56E91;
}
header .header_menu .web_main {
  display: none;
  position: absolute;
  right: 0;
  top: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.85);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 50px;
  transition: all 0.2s ease-in-out;
  z-index: 10;
}
@media (max-width: 998px) {
  header .header_menu .web_main {
    display: flex;
  }
}
header .header_menu .web_main a {
  padding: 10px 0;
  font-size: clamp(1.875rem, 1.2833rem + 2.9586vw, 3.125rem);
  font-weight: 700;
  color: #555;
  transition: all 0.2s ease-in-out;
}
@media (max-width: 769px) {
  header .header_menu .web_main a {
    padding: 0;
  }
}
header .header_menu .web_main a.link {
  color: #fff;
}
header .header_menu .web_main a.active {
  color: #F56E91;
}
header .header_menu .web_main a.hover {
  color: #F56E91;
}

.burger_menu {
  z-index: 11;
  display: none;
}
@media (max-width: 998px) {
  .burger_menu {
    display: block;
  }
}
.burger_menu .checkboxtoggler {
  width: 40px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  cursor: pointer;
}
.burger_menu .checkboxtoggler .line-1 {
  background: #000;
  height: 0.3em;
  border-radius: 10em;
  transition-duration: 500ms;
  caret-color: transparent;
}
.burger_menu .checkboxtoggler .line-2 {
  background: #000;
  height: 0.3em;
  border-radius: 10em;
  transition-duration: 500ms;
  caret-color: transparent;
}
.burger_menu .checkboxtoggler .line-3 {
  background: #000;
  height: 0.3em;
  border-radius: 10em;
  transition-duration: 500ms;
  caret-color: transparent;
}
.burger_menu #toggleChecker {
  height: 3em;
  width: 100%;
  display: none;
}
.burger_menu #toggleChecker:checked + #togglerLable .checkboxtoggler .line-1 {
  transform: rotate(45deg) translateY(0.7em) translateX(0.7em);
  background-color: #F56E91;
}
.burger_menu #toggleChecker:checked + #togglerLable .checkboxtoggler .line-2 {
  transform: rotate(-45deg) translateY(0em) translateX(0.1em);
  background-color: #F56E91;
}
.burger_menu #toggleChecker:checked + #togglerLable .checkboxtoggler .line-3 {
  transform: scaleX(0);
  transform-origin: left;
  background-color: #F56E91;
}

.slider ul.slick-dots {
  bottom: 30px !important;
}
.slider .slide-bg .slick-slider,
.slider .slide-bg .slick-list {
  overflow: hidden;
  width: 100%;
}
.slider .slide-bg .img-block {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
}
@media (max-width: 600px) {
  .slider .slide-bg .img-block {
    width: 100%;
  }
}
.slider .slide-bg .img-block img {
  max-width: 100%;
  width: 100vw;
  height: calc(100vh - 155px);
  object-fit: cover;
}
@media (max-width: 600px) {
  .slider .slide-bg .img-block img {
    height: 400px;
  }
}
.slider .slide-bg .img-block .slider-text-block {
  width: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: clamp(1.25rem, 1.1542rem + 2.1898vw, 3.125rem);
}
.slider .slide-bg .img-block .slider-text-block .slider-title {
  font-family: Roboto, sans-serif;
  color: #000;
  font-size: clamp(2.25rem, 1.6429rem + 3.0357vw, 4.375rem);
  font-weight: 300;
  text-transform: uppercase;
  padding-left: 10%;
}
.slider .slide-bg .img-block .slider-text-block .slider-text {
  border-left: 9px solid #F56E91;
  height: 80px;
  padding-left: 24px;
  display: flex;
  align-items: center;
  margin-left: 10%;
}
@media (max-width: 600px) {
  .slider .slide-bg .img-block .slider-text-block .slider-text {
    height: 100%;
  }
}
.slider .slide-bg .img-block .slider-text-block .slider-text .slider-description {
  color: #0B1203;
  font-family: Roboto, sans-serif;
  font-size: clamp(1.25rem, 0.8929rem + 1.7857vw, 2.5rem);
  font-weight: 500;
  text-transform: uppercase;
}
.slider .slide-bg .img-block .slider-text-block .deliver {
  width: clamp(17.5rem, 9.8749rem + 38.1257vw, 44.188rem);
  height: clamp(3.125rem, 2.6964rem + 2.1429vw, 4.625rem);
  background: #B0D404;
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 10px 25px 10px 0;
  gap: 30px;
}
@media (max-width: 600px) {
  .slider .slide-bg .img-block .slider-text-block .deliver {
    width: 100%;
  }
}
.slider .slide-bg .img-block .slider-text-block .deliver .delivery-title {
  color: #FFF;
  font-family: Roboto, sans-serif;
  font-size: clamp(1.0625rem, 0.8304rem + 1.1607vw, 1.875rem);
  display: flex;
  flex-direction: column;
  text-transform: uppercase;
}
.slider .slide-bg .img-block .slider-text-block .deliver .delivery-title span {
  display: block;
  color: #FFF;
  font-size: clamp(1rem, 0.8929rem + 0.5357vw, 1.375rem);
  font-weight: 300;
}

.categories {
  max-width: 1440px;
  margin: 0 auto;
  padding: 50px 10px;
}
.categories .categories-img-block {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
}
@media (max-width: 700px) {
  .categories .categories-img-block {
    flex-direction: column;
  }
}
.categories .categories-img-block .categories-img {
  max-width: 100%;
  width: 400px;
  height: clamp(12.5rem, 5.8036rem + 17.8571vw, 21.875rem);
  object-fit: cover;
}
.categories .categories-img-block .our-products-text {
  font-size: clamp(1.125rem, 0.3661rem + 2.0238vw, 2.1875rem);
}
@media (max-width: 700px) {
  .categories .categories-img-block .our-products-text {
    font-size: clamp(1.5625rem, 2.5018rem - 0.0047vw, 2.5rem);
  }
}
.categories .categories-img-block .our-products-text svg {
  width: clamp(1.125rem, 0.3661rem + 2.0238vw, 2.1875rem);
}

.section_padding {
  padding: 35px 0;
}
@media (max-width: 600px) {
  .section_padding {
    padding: 0 0 35px 0;
  }
}
.section_padding .contact_info {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  gap: 70px;
  margin-top: 90px;
  padding: 0 160px;
}
@media (max-width: 1320px) {
  .section_padding .contact_info {
    gap: 30px;
  }
}
@media (max-width: 1201px) {
  .section_padding .contact_info {
    max-width: 1440px;
    margin: 0 auto;
    padding: 50px;
  }
}
@media (max-width: 728px) {
  .section_padding .contact_info {
    padding: 15px;
  }
}
.section_padding .contact_info .contact_title {
  width: calc(50% - 70px);
  display: flex;
  flex-direction: column;
  gap: 50px;
}
@media (max-width: 1201px) {
  .section_padding .contact_info .contact_title {
    width: 100%;
    flex-direction: row;
    align-items: center;
  }
}
@media (max-width: 600px) {
  .section_padding .contact_info .contact_title {
    flex-direction: column;
  }
}
.section_padding .contact_info .contact_title .contact_list {
  max-width: 560px;
  border: 1px solid #E5E5E5;
  position: relative;
  padding: 40px 50px;
  border-left: 8px solid #B0D404;
}
@media (max-width: 600px) {
  .section_padding .contact_info .contact_title .contact_list {
    padding: 20px;
  }
}
.section_padding .contact_info .contact_title .contact_list .contact_address {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
}
.section_padding .contact_info .contact_title .contact_list .contact_address h4 {
  color: #000;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.48px;
  text-transform: uppercase;
}
.section_padding .contact_info .contact_title .contact_list .contact_address p {
  color: #A3A3A3;
  font-family: "Inter", sans-serif;
  font-size: 17px;
  font-weight: 500;
  line-height: 27px;
}
.section_padding .contact_info .contact_title .contact_list .contact_address a {
  color: #F56E91;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 34px;
  cursor: pointer;
}
.section_padding .contact_info .contact_title .contact_list h3 {
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.48px;
}
.section_padding .contact_info .contact_title .contact_list .contact_open {
  color: #B0D404;
}
.section_padding .contact_info .contact_title .contact_list .contact_closed {
  color: #F56E91;
}
.section_padding .contact_info .contact_title .contact_text {
  color: #000;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 26px;
}
.section_padding .contact_map {
  width: calc(50% - 70px);
  z-index: 5;
}
@media (max-width: 1200px) {
  .section_padding .contact_map {
    width: 100%;
  }
}
@media (max-width: 650px) {
  .section_padding .contact_map .leaflet-popup.leaflet-zoom-animated {
    opacity: 0 !important;
  }
}
.section_padding .contact_map .leaflet-popup-content {
  width: 400px !important;
}
.section_padding .contact_map .map_info {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  align-items: center;
}
.section_padding .contact_map .map_info .map_img {
  max-width: 100%;
  width: 142px;
}
.section_padding .contact_map .map_info .map_text {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}
.section_padding .contact_map .map_info .map_text h5 {
  color: #000;
  font-size: 15px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.48px;
  text-transform: uppercase;
}
.section_padding .contact_map .map_info .map_text p {
  color: #AAA;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 27px;
  margin: 5px 0;
}
.section_padding .contact_map .map_info .map_text span {
  color: #AAA;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 34px;
}

.about_text {
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 1000px;
  margin: 5% auto;
  padding: 0 30px;
}
.about_text p {
  font-size: 16px;
  line-height: 34px;
  text-align: justify;
  text-align: justify;
}

.products {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 15px;
}
.products .product_filer {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  padding: 40px 0;
  gap: 40px;
}
@media (max-width: 735px) {
  .products .product_filer {
    justify-content: center;
  }
}
.products .product_filer .product_name {
  overflow-x: auto;
  scrollbar-width: none;
}
.products .product_filer .product_name ul {
  display: flex;
  gap: clamp(0.625rem, 0.4464rem + 0.8929vw, 1.25rem);
  list-style: none;
}
.products .product_filer .product_name ul li {
  cursor: pointer;
  font-weight: 700;
  text-transform: uppercase;
}
.products .product_filer .product_name ul li.active {
  color: #F56E91;
}
.products .product_filer .product_search {
  position: relative;
}
.products .product_filer .product_search input {
  position: relative;
  border-radius: 8px;
  border: 1px solid #D6D6D6;
  height: 50px;
  width: clamp(17.5rem, 17.1429rem + 1.7857vw, 18.75rem);
  padding: 0 16px;
  outline: none;
  font-size: 16px;
}
.products .product_filer .product_search .glass_icon {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.data_img {
  max-width: 100%;
  width: 100%;
  height: 244px;
  object-fit: cover;
  border-radius: 10px;
  cursor: pointer;
}

.products_data {
  display: flex;
  justify-content: center;
  align-content: stretch;
  align-items: stretch;
  gap: 36px;
  flex-wrap: wrap;
  min-height: 500px;
}
@media (max-width: 450px) {
  .products_data {
    min-height: 100%;
  }
}

.data-frame {
  border-radius: 20px;
  border: 1px solid #B7B5B5;
  background: #FFF;
  padding: 24px;
  height: 460px;
  width: 300px;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
}
.data-frame .cart-frame {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-top: 30px;
  gap: 16px;
}
.data-frame .slick-dots {
  bottom: -20px;
}
.data-frame .data_title {
  font-size: 20px;
  font-weight: 700;
  text-align: center;
}
.data-frame .data_price {
  display: flex;
  justify-content: center;
  gap: 16px;
  align-items: center;
}
.data-frame .data_price .data_discount {
  color: #ABABAB;
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
  text-decoration: line-through;
}
.data-frame .data_price .data_count {
  color: #F56E91;
  font-size: 18px;
  font-weight: 800;
  line-height: normal;
}

.data_buttons {
  display: flex;
  justify-content: space-evenly;
  gap: 16px;
  align-items: center;
}

.data_add-button {
  border-radius: 8px;
  background: #B0D404;
  width: 100%;
  padding: 10px 0;
  color: #fff;
  border: 1px solid transparent;
  font-size: 20px;
  font-weight: 700;
  cursor: pointer;
}

.data_added-button {
  background: #fff;
  color: #B0D404;
  border: 1px solid #B0D404;
  border-radius: 8px;
  width: 100%;
  padding: 10px;
  font-size: 20px;
  font-weight: 700;
  cursor: pointer;
}

.data_remove-button {
  border-radius: 8px;
  background: #df2656;
  width: 100%;
  padding: 10px 0;
  color: #fff;
  border: none;
  font-size: 22px;
  font-weight: 700;
  cursor: pointer;
}

.data_heartIcon {
  padding: 7px 15px;
  border-radius: 8px;
  background: #F2F0F0;
  cursor: pointer;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 50px;
}
.pagination .MuiPagination-ul button {
  border: none;
  color: #aaa;
  font-size: 20px;
  font-weight: 700;
  width: 45px;
  height: 45px;
}
.pagination .MuiPagination-ul button svg {
  font-size: 30px;
}
.pagination .MuiPagination-ul .Mui-selected {
  border-radius: 8px;
  background: #F56E91;
  border: none;
  color: #fff;
}

.favorites_title {
  max-width: 1440px;
  margin: 0 auto;
  padding: 50px 0;
}

.empty-favorites {
  position: relative;
}
.empty-favorites .empty-favorites_inner {
  position: absolute;
  left: 50%;
  right: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
  top: 50%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  align-items: center;
  z-index: 2;
  text-align: center;
  padding: 0 15px;
}
.empty-favorites .empty-favorites_inner h3 {
  color: #000;
  font-family: "Inter", sans-serif;
  font-size: clamp(1rem, 0.6429rem + 1.7857vw, 2.25rem);
}
.empty-favorites .empty-favorites_inner p {
  color: #4F4F4F;
  font-family: Inter, sans-serif;
  font-size: clamp(0.75rem, 0.6429rem + 0.5357vw, 1.125rem);
}

.single-page {
  display: flex;
  justify-content: center;
  gap: 60px;
  padding: clamp(0.9375rem, -1.1546rem + 10.4603vw, 4.0625rem) 15px;
  max-width: 1440px;
  margin: 0 auto;
}
@media (max-width: 798px) {
  .single-page {
    flex-direction: column;
  }
}
.single-page .single-page_slider {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: 15px;
  height: 530px;
}
@media (max-width: 1100px) {
  .single-page .single-page_slider {
    flex-direction: column;
    height: 100%;
  }
}
.single-page .single-page_slider .slider_image {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  max-width: 100%;
  width: clamp(23.125rem, 1.6556rem + 43.0464vw, 31.25rem);
}
@media (max-width: 798px) {
  .single-page .single-page_slider .slider_image {
    width: 100%;
  }
}
.single-page .single-page_slider .slider_image .single_slide-title {
  max-width: 100%;
  height: 545px;
  border-radius: 16px;
  padding: 35px;
  background-color: #F8F8F8;
}
@media (max-width: 798px) {
  .single-page .single-page_slider .slider_image .single_slide-title {
    height: clamp(24.375rem, 17.262rem + 35.5649vw, 35rem);
    padding: clamp(0.9375rem, 0.1007rem + 4.1841vw, 2.1875rem);
  }
}
.single-page .single-page_slider .slider_image .single_slide-title .single_slide-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 16px;
}
.single-page .single-page_slider .slider_image .slick-slider.slick-initialized {
  width: clamp(23.125rem, 1.6556rem + 43.0464vw, 31.25rem);
  max-width: 100%;
}
@media (max-width: 798px) {
  .single-page .single-page_slider .slider_image .slick-slider.slick-initialized {
    width: 100%;
  }
}

.single-page_title {
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: clamp(1.25rem, 0.7143rem + 2.6786vw, 3.125rem);
}
@media (max-width: 798px) {
  .single-page_title {
    margin: 0 auto;
    text-align: center;
  }
}
.single-page_title .sigle-page_items-count {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.single-page_title .single-page_text,
.single-page_title .single-page_price {
  display: flex;
  flex-direction: column;
  gap: clamp(0.9375rem, 1.1467rem - 1.046vw, 0.625rem);
}
.single-page_title .btn-group {
  display: flex;
  align-items: center;
}
.single-page_title .single-page_text h3 {
  color: #000;
  font-family: "Inter", sans-serif;
  font-size: 30px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: capitalize;
}
@media (max-width: 768px) {
  .single-page_title .single-page_text h3 {
    font-size: clamp(1.25rem, 0.8316rem + 2.0921vw, 1.875rem);
  }
}
.single-page_title .single-page_text p {
  color: #828282;
  font-size: 16px;
  line-height: 25px;
  text-transform: capitalize;
  text-align: justify;
}
.single-page_title .single-page_count {
  display: flex;
  gap: 20px;
}
@media (max-width: 798px) {
  .single-page_title .single-page_count {
    justify-content: center;
  }
}
.single-page_title .single-page_count span {
  font-size: 20px;
  letter-spacing: 1.25px;
  text-transform: uppercase;
}
.single-page_title .single-page_count .page_discount {
  color: #939393;
  text-decoration-line: line-through;
}
.single-page_title .single-page_count .page_count {
  color: #F56E91;
  font-weight: 700;
}

.small_slider {
  position: relative;
}
@media (max-width: 1100px) {
  .small_slider {
    display: block;
    width: 400px;
  }
}
@media (max-width: 798px) {
  .small_slider {
    display: block;
    width: 400px;
  }
}
@media (max-width: 470px) {
  .small_slider {
    display: block;
    width: 250px;
  }
}
@media (max-width: 400px) {
  .small_slider {
    display: none;
  }
}
.small_slider .slick-slider.slick-initialized {
  margin-right: 50px;
}
@media (max-width: 1100px) {
  .small_slider .slick-slider.slick-initialized {
    margin-right: 0;
  }
}
@media (max-width: 798px) {
  .small_slider .slick-slider.slick-initialized {
    width: 100%;
  }
}
.small_slider .slick-slider.slick-initialized .slick-track {
  height: 100% !important;
  width: 120px;
}
.small_slider .slick-slider.slick-initialized .slick-disabled {
  background-color: red !important;
}
.small_slider .slick-slider.slick-initialized .arrowNext,
.small_slider .slick-slider.slick-initialized .arrowPrev {
  background-color: #F8F8F8;
  width: 36px;
  height: 34px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  position: absolute;
  border: none;
}
.small_slider .slick-slider.slick-initialized .arrowNext {
  top: -40px;
  left: 50%;
  right: 50%;
  transform: translate(-50%, -50%);
}
@media (max-width: 1100px) {
  .small_slider .slick-slider.slick-initialized .arrowNext {
    top: 50%;
    left: calc(100% + 15px);
    transform: translate(-50%, -50%) rotate(90deg);
  }
}
@media (max-width: 798px) {
  .small_slider .slick-slider.slick-initialized .arrowNext {
    top: 50%;
    left: calc(100% + 15px);
    transform: translate(-50%, -50%) rotate(90deg);
  }
}
.small_slider .slick-slider.slick-initialized .arrowPrev {
  top: calc(100% + 34px);
  left: 50%;
  right: 50%;
  transform: translate(-50%, -50%);
}
@media (max-width: 1100px) {
  .small_slider .slick-slider.slick-initialized .arrowPrev {
    left: -25px;
    transform: translate(-50%, -50%) rotate(90deg);
    top: 50%;
  }
}
@media (max-width: 798px) {
  .small_slider .slick-slider.slick-initialized .arrowPrev {
    left: -25px;
    transform: translate(-50%, -50%) rotate(90deg);
    top: 50%;
  }
}
.small_slider .slider_image-item {
  background-color: #F8F8F8;
  padding: 20px 18px;
  width: 120px !important;
  height: 135px;
  border-radius: 16px;
}
.small_slider .slider_image-item img {
  max-width: 100%;
  width: 100%;
  height: 100%;
  cursor: pointer;
  object-fit: cover;
}

.navigation {
  display: flex;
  gap: 10px;
  padding-left: clamp(0.9375rem, 0.0446rem + 4.4643vw, 4.0625rem);
  flex-wrap: wrap;
}
@media (max-width: 600px) {
  .navigation {
    display: none;
  }
}
.navigation a, .navigation span {
  color: #958D8D;
  font-size: 15px;
  font-weight: 400;
}
.navigation .navigate_link-color {
  color: #F56E91;
  font-family: "Inter", sans-serif;
  font-size: 15px;
  font-weight: 700;
}

.navigation_title {
  color: #000;
  font-family: "Inter", sans-serif;
  font-size: clamp(1.25rem, 1.0714rem + 0.8929vw, 1.875rem);
  font-weight: 400;
  padding: 25px 0 25px clamp(0.9375rem, 0.0446rem + 4.4643vw, 4.0625rem);
  border-bottom: 2px solid #CFCFCF;
}

.navigation_frame {
  max-width: 100%;
  height: 150px;
  position: relative;
}
@media (max-width: 850px) {
  .navigation_frame {
    height: 100px;
  }
}
.navigation_frame img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: relative;
}
.navigation_frame img::before {
  content: "";
  width: 100%;
  height: auto;
  position: absolute;
  left: 0;
  top: 0;
  background-color: red;
}
.navigation_frame span {
  width: 100%;
  height: 100%;
  background: rgba(245, 110, 145, 0.8);
  display: block;
  position: absolute;
  top: 0;
}
.navigation_frame .layer_title {
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.72px;
  text-transform: uppercase;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
}
@media (max-width: 850px) {
  .navigation_frame .layer_title {
    font-size: 18px;
  }
}

.who-we-are-body {
  position: relative;
}
.who-we-are-body .style-svg {
  position: absolute;
  z-index: 1;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  inset: 50% 50% 0 50%;
}
.who-we-are-body .style-svg svg {
  width: 100%;
  padding: 0 20px;
}
.who-we-are-body .who-we-are-info-block {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: clamp(1.875rem, -9.7917rem + 20.7407vw, 8.875rem);
  flex-wrap: wrap;
  padding-top: clamp(1.5rem, 0.8571rem + 3.2143vw, 3.75rem);
  padding-bottom: clamp(2.5rem, 1.4286rem + 5.3571vw, 6.25rem);
  position: relative;
}
.who-we-are-body .who-we-are-info-block .who-we-are-img-block {
  padding: 20px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 530px) {
  .who-we-are-body .who-we-are-info-block .who-we-are-img-block {
    width: 80%;
  }
}
.who-we-are-body .who-we-are-info-block .who-we-are-img-block::after {
  border-top: 10px solid #F56E91;
  border-right: 10px solid #F56E91;
  position: absolute;
  content: "";
  width: 100px;
  height: 100px;
  top: 0;
  right: 0;
}
.who-we-are-body .who-we-are-info-block .who-we-are-img-block:before {
  content: "";
  width: 111px;
  height: 113px;
  background-color: #EDEDED;
  z-index: 1;
  position: absolute;
  bottom: -20px;
  left: -20px;
}
.who-we-are-body .who-we-are-info-block .who-we-are-img-block img {
  max-width: 100%;
  height: 95%;
  z-index: 5;
}
@media (max-width: 530px) {
  .who-we-are-body .who-we-are-info-block .who-we-are-img-block img {
    max-width: 100%;
  }
}
.who-we-are-body .who-we-are-info-block .who-we-are-text-block {
  width: clamp(18.75rem, 16.6071rem + 10.7143vw, 26.25rem);
  padding: 0 20px;
  z-index: 1;
}
@media (max-width: 884px) {
  .who-we-are-body .who-we-are-info-block .who-we-are-text-block {
    width: 80%;
  }
}
@media (max-width: 600px) {
  .who-we-are-body .who-we-are-info-block .who-we-are-text-block {
    width: 100%;
  }
}
.who-we-are-body .who-we-are-info-block .who-we-are-text-block .who-we-are-text-info .who-we-are-title {
  color: #4D4D4D;
  font-family: "Inter", sans-serif;
  font-size: clamp(2rem, 1.8571rem + 0.7143vw, 2.5rem);
  font-weight: 500;
  margin-bottom: 30px;
}
.who-we-are-body .who-we-are-info-block .who-we-are-text-block .who-we-are-text-info .who-we-are-text {
  color: #6F6F6F;
  font-family: "Inter", sans-serif;
  font-size: clamp(1rem, 0.9643rem + 0.1786vw, 1.125rem);
  font-weight: 500;
  line-height: 30px;
  text-align: justify;
}
.who-we-are-body .who-we-are-info-block .who-we-are-text-block .who-we-are-text-info .who-we-are-description {
  min-height: 115px;
  border-left: 9px solid #B0D404;
  padding-left: 20px;
  margin: 28px 0 0 15px;
  color: #6F6F6F;
  font-family: "Inter", sans-serif;
  font-size: clamp(0.7rem, 0.9643rem + 0.1786vw, 1.125rem);
  font-weight: 500;
  line-height: 30px;
  text-align: justify;
}
@media (max-width: 600px) {
  .who-we-are-body .who-we-are-info-block .who-we-are-text-block .who-we-are-text-info .who-we-are-description {
    margin-left: 0;
  }
}

.discount-bg {
  position: relative;
}
.discount-bg .discountBg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
@media (max-width: 600px) {
  .discount-bg .discountBg {
    height: 160px;
  }
}
.discount-bg .discount-block {
  position: absolute;
  top: 0;
  padding-left: 120px;
  height: 100%;
  display: flex;
  align-items: center;
}
@media (max-width: 800px) {
  .discount-bg .discount-block {
    padding-left: 60px;
  }
}
.discount-bg .discount-block .discount-title {
  color: #F56E91;
  font-family: Roboto, sans-serif;
  font-size: clamp(2.25rem, 1.8214rem + 2.1429vw, 3.75rem);
  font-weight: 900;
}
.discount-bg .discount-block .discount-description {
  color: rgba(71, 28, 28, 0.9);
  font-family: Roboto, sans-serif;
  font-size: clamp(1rem, 0.5714rem + 2.1429vw, 2.5rem);
  font-weight: 300;
}

.our-products-block {
  padding: 50px 0;
}
.our-products-title {
  display: flex;
  gap: 30px;
}
@media (max-width: 600px) {
  .our-products-title {
    flex-direction: column;
    margin-bottom: 0;
    padding: 0 30px;
  }
}
.our-products-title .our-products-img-item {
  flex: 1 1 45%;
}
.our-products-title .our-products-img-item .our-products-img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
@media (max-width: 600px) {
  .our-products-title .our-products-img-item .our-products-img {
    height: 300px;
    max-width: 100%;
  }
}

.our-products-img-item {
  position: relative;
  cursor: pointer;
  transition: all ease-in-out 0.3s;
  z-index: 1;
}
.our-products-img-item::after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  background-color: #FD8CA9;
  width: 100%;
  height: 100%;
  transition: all ease-in-out 0.5s;
  z-index: 2;
}
.our-products-img-item:hover::after {
  opacity: 0.7;
}
.our-products-img-item:hover .our-products-text {
  top: 50%;
  bottom: 30%;
  transform: translateY(-50%);
}
.our-products-img-item .our-products-img {
  position: relative;
  transition: all ease-in-out 0.5s;
}
.our-products-img-item .our-products-text {
  position: absolute;
  bottom: 14%;
  color: #FFF;
  font-size: clamp(1.25rem, 0.3571rem + 2.381vw, 2.5rem);
  font-weight: 300;
  text-transform: uppercase;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: CENTER;
  gap: 15px;
  z-index: 10;
  transform: translateY(50%);
  top: 90%;
  transition: all ease-in-out 0.5s;
}
@media (max-width: 600px) {
  .our-products-img-item .our-products-text {
    justify-content: flex-end;
    padding-right: 10%;
    font-size: clamp(1.5625rem, 0.4911rem + 5.3571vw, 2.5rem);
  }
}
.our-products-img-item .our-products-text svg {
  width: clamp(1.25rem, 0.3571rem + 2.381vw, 2.5rem);
}

.title-header {
  color: #000;
  font-family: "Inter", sans-serif;
  font-size: clamp(1.25rem, 0.8036rem + 2.2321vw, 2.8125rem);
  padding: 40px 60px;
  position: relative;
  display: inline-block;
  font-weight: 700;
}
@media (max-width: 600px) {
  .title-header {
    text-align: center;
    width: 100%;
    padding: 40px 0;
  }
}
.title-header::before {
  content: "";
  display: block;
  width: clamp(4.1875rem, 2.7946rem + 6.9643vw, 9.0625rem);
  height: 5px;
  background-color: #B0D404;
  position: absolute;
  top: 30px;
  left: 50%;
  right: 50%;
  transform: translate(-50%, -50%);
}

.special-order .special-order-block-bg {
  background: #fff;
  outline: none;
  padding-bottom: 80px;
}
.special-order .slick-slider .slick-list {
  margin: -10px 0;
}
.special-order .slick-slider .slick-list .slick-track .slick-slide {
  display: grid;
  place-items: center;
}
.special-order .slick-slider .slick-list .slick-track .slick-slide > div {
  padding: 10px 0;
}
.special-order .slick-slider .slick-dots {
  bottom: -35px;
}

.our-partners-block-title {
  text-align: center;
  color: #000;
  font-family: "Inter";
  font-size: 35px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 20px;
}

.our-partners-bg {
  background: #fff;
  width: 80% !important;
  height: 118px;
  display: flex !important;
  justify-content: center;
  align-items: center;
}
@media (max-width: 480px) {
  .our-partners-bg {
    width: 100% !important;
  }
}

.our-client-opinion {
  background: #FD8CA9;
  text-align: center;
  padding: 45px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: revert;
  position: relative;
}
.our-client-opinion .slick-dots li {
  width: 15px;
  height: 15px;
  background-color: #fff;
  border: 1px solid #fff;
  border-radius: 50%;
}
.our-client-opinion .slick-dots li button::before {
  font-size: 0;
}
.our-client-opinion .slick-dots .slick-active {
  background-color: transparent;
}
.our-client-opinion .slick-prev,
.our-client-opinion .slick-next {
  top: calc(50% - 50px);
}
.our-client-opinion .our-client-opinion-block-title {
  color: #FFF;
  text-align: center;
  font-family: Roboto, sans-serif;
  font-size: clamp(1.5rem, -1.1667rem + 13.3333vw, 2.5rem);
  text-transform: capitalize;
  padding: 0 15px;
}
.our-client-opinion .our-client-opinion-block-bg {
  width: 80%;
  margin-top: 50px;
}
.our-client-opinion .our-client-opinion-block-bg .our-client_opinion-bg .our-client_slider-text {
  width: 80%;
  padding: 0 10px;
  margin: 0 auto;
}
@media (max-width: 600px) {
  .our-client-opinion .our-client-opinion-block-bg .our-client_opinion-bg .our-client_slider-text {
    width: 100%;
  }
}
.our-client-opinion .our-client-opinion-block-bg .our-client_opinion-bg .our-client_slider-text p {
  color: #FFF;
  font-family: Roboto, sans-serif;
  font-size: 19px;
  line-height: 26px;
}
.our-client-opinion .our-client-opinion-block-bg .our-client_opinion-bg .our-client_slider-text .our-client_slider-description {
  font-size: clamp(0.875rem, 0.0417rem + 4.1667vw, 1.1875rem);
}
.our-client-opinion .our-client-opinion-block-bg .our-client_opinion-bg .our-client_slider-text .our-client_user-name {
  margin-top: 25px;
}

.our-client-opinion-block-bg .slick-arrow.slick-prev:before {
  content: "" !important;
}

.our-client-opinion-block-bg .slick-next.slick-next::before {
  content: "" !important;
}

.categrias-item-mine-block {
  display: flex;
  justify-content: space-around;
  width: 80%;
  margin: auto;
  border: 1px solid red;
}
.categrias-item-mine-block .categrias-item-mine-block-slide,
.categrias-item-mine-block .categrias-item-mine-block-info {
  width: 48%;
  border: 1px solid green;
}

.payment .payment-method {
  padding: clamp(1.25rem, -0.5793rem + 9.1463vw, 3.125rem) 15px;
  border-bottom: 1px solid #C0C0C0;
}
.payment .payment-method .payment-method_form {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: clamp(1.25rem, 0.7143rem + 2.6786vw, 3.125rem);
}
@media (max-width: 648px) {
  .payment .payment-method .payment-method_form {
    flex-direction: column;
    align-items: flex-start;
    align-content: center;
  }
}
.payment .payment-method .payment-method_form .payment-method_label {
  display: flex;
  gap: 10px;
  align-items: center;
  cursor: pointer;
}
.payment .payment-method .payment-method_form .payment-method_label img {
  width: 100px;
}
.payment .payment-method .payment-method_form .payment-method_label .payment-name {
  font-size: 16px;
}
.payment .payment-order {
  padding: 60px 20px;
  display: flex;
  justify-content: center;
  gap: clamp(1.25rem, -0.1786rem + 7.1429vw, 6.25rem);
}
@media (max-width: 769px) {
  .payment .payment-order {
    flex-wrap: wrap;
    padding: 15px 15px 30px 15px;
  }
}
.payment .payment-order .my-order {
  padding: 20px 0;
}
.payment .payment-order .my-order h3 {
  margin-bottom: 30px;
  color: #000;
  font-size: 24px;
  font-weight: 500;
  text-transform: capitalize;
}
.payment .payment-order .my-order .my-order_lists-group {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.payment .payment-order .my-order .my-order_lists-group .my-order_list {
  display: flex;
  gap: 20px;
  align-items: center;
}
.payment .payment-order .my-order .my-order_lists-group .my-order_list .order-img {
  max-width: 100%;
  width: 90px;
}
.payment .payment-order .my-order .my-order_lists-group .my-order_list .order-inner {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.payment .payment-order .my-order .my-order_lists-group .my-order_list .order-inner .order_name {
  color: #B2B2B2;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.8px;
}
.payment .payment-order .my-order .my-order_lists-group .my-order_list .order-inner .order_title-name {
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 23px;
}
.payment .payment-order .my-order .my-order_lists-group .my-order_list .order-inner .order-price {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}
.payment .payment-order .my-order .my-order_lists-group .my-order_list .order-inner .order-price .order_price-discount {
  color: #939393;
}
.payment .payment-order .my-order .my-order_lists-group .my-order_list .order-inner .order-price .order_price-count {
  color: #F23969;
}
.payment .payment-order .order-divider {
  width: 1px;
  height: auto;
  background: #A2A2A2;
}
@media (max-width: 769px) {
  .payment .payment-order .order-divider {
    width: 100%;
    height: 1px;
  }
}
.payment .payment-order .order-summary {
  padding: 20px 0;
  width: 360px;
}
.payment .payment-order .order-summary h3 {
  margin-bottom: 30px;
  color: #000;
  font-size: 24px;
  font-weight: 500;
  text-transform: capitalize;
}
.payment .payment-order .order-summary .order-summary_inner {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 30px;
  height: calc(100% - 40px);
}
.payment .payment-order .order-summary .order-summary_inner .summary-title {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 15px;
  width: 100%;
}
.payment .payment-order .order-summary .order-summary_inner .summary-title .summary_inner {
  display: flex;
  justify-content: space-between;
}
.payment .payment-order .order-summary .order-summary_inner .summary-title .summary_inner .subtotal-text {
  color: #999;
  font-size: 16px;
  font-weight: 500;
}
.payment .payment-order .order-summary .order-summary_inner .summary-title .summary_inner .subtotal-price {
  font-size: 16px;
  font-weight: 500;
}
.payment .payment-order .order-summary .order-summary_inner .summary-title .summary_inner .summary_total-price {
  color: #F56E91;
  font-size: 24px;
  font-weight: 700;
}
.payment .payment-order .order-summary .order-summary_inner .summary-title .summary-divider {
  width: 100%;
  height: 1px;
  background-color: #A2A2A2;
  margin: 20px 0;
}
.payment .payment-order .order-summary .summary-button {
  display: flex;
  justify-content: flex-end;
  gap: 30px;
}
.payment .payment-order .order-summary .summary-button button {
  font-size: 20px;
  font-weight: 500;
  border-radius: 8px;
  border: none;
  padding: 10px 25px;
  cursor: pointer;
  width: 100%;
}
.payment .payment-order .order-summary .summary-button .cancel-btn {
  color: #8E8E8E;
  border: 1px solid #C2C2C2;
}
.payment .payment-order .order-summary .summary-button .buy-btn {
  color: #fff;
  border-radius: 8px;
  background: #B0D404;
}
.payment .policy-text {
  text-align: center;
  max-width: 580px;
  margin: 0 auto;
  padding: 0 20px;
  color: #757575;
  font-size: 14px;
  text-transform: capitalize;
  line-height: 23px;
}
.payment .policy-text a {
  text-decoration-line: underline;
}

.order-message {
  position: absolute;
  width: 400px;
  height: 200px;
  background: #b0d404;
  color: #fff;
  left: 50%;
  right: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 26px;
  text-align: center;
  letter-spacing: 2px;
}

.cart_table-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.cart_table-section .table_form {
  max-width: 1440px;
  padding-bottom: 20px;
}
.cart_table-section .table_form .cart_table {
  margin: 0 auto;
  border-collapse: collapse;
  padding: 0;
  width: 100%;
}
.cart_table-section .table_form .cart_head {
  height: 64px;
}
.cart_table-section .table_form .cart_title {
  border-bottom: 1px solid #cdcdcd;
}
.cart_table-section .table_form .cart_title th {
  text-align: center;
  color: #000;
  font-size: 16px;
  letter-spacing: 0.8px;
  text-transform: capitalize;
}
@media (max-width: 768px) {
  .cart_table-section tbody.item-body {
    display: flex;
    gap: 30px;
    flex-wrap: wrap;
  }
}
@media (max-width: 640px) {
  .cart_table-section tbody.item-body {
    display: block;
  }
  .cart_table-section .responsiveTable td .tdBefore {
    display: block;
  }
  .cart_table-section .responsiveTable td.pivoted {
    display: flex;
    align-items: center;
  }
  .cart_table-section tr.item {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    border: none;
    border-bottom: 1px solid #8E8E8E;
  }
  .cart_table-section .item .item_description .item_title {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 100%;
  }
}
@media (max-width: 640px) and (max-width: 420px) {
  .cart_table-section .item .item_description .item_title {
    display: none;
  }
}
@media (max-width: 640px) {
  .cart_table-section .tdBefore {
    font-size: 15px;
  }
}

.item_description {
  display: flex;
  gap: 20px;
  align-items: center;
}
.item_description .item_img {
  padding: 15px;
  border-radius: 16px;
  background: #F8F8F8;
  display: flex;
  align-items: center;
  justify-content: center;
}
.item_description .item_img img {
  width: 190px;
  height: 140px;
  max-width: 100%;
  object-fit: cover;
}
.item_description .item_title {
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
  gap: 20px;
}
@media (max-width: 850px) {
  .item_description .item_title {
    display: none;
  }
}
@media (max-width: 768px) {
  .item_description .item_title {
    gap: 10px;
    align-items: center;
    display: flex;
  }
}
@media (max-width: 640px) {
  .item_description .item_title {
    gap: 10px;
    align-items: flex-start;
  }
}
.item_description .item_title .item_text {
  color: #000;
  font-size: 16px;
  font-weight: 500;
}
.item_description .item_title .item-count {
  color: #F23969;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}
.item_description .item_title .item-count span {
  color: #939393;
  font-size: 16px;
  letter-spacing: 0.8px;
  text-decoration-line: line-through;
  text-transform: uppercase;
  padding-right: 20px;
}

.item_input .btn-group {
  display: flex;
  align-items: center;
  justify-content: center;
}
.item_input button {
  padding: 0 12px;
  border-radius: 8px;
  background: #F2F2F2;
  border: none;
  font-size: 24px;
  cursor: pointer;
  width: 30px;
  height: 30px;
}
.item_input .item_quantityCount {
  margin: 0 10px;
  font-size: 20px;
}

.item_subtotal {
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.9px;
  text-transform: uppercase;
}

.item_date input {
  width: 152px;
  height: 44px;
  padding: 15px;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  background: #F6F6F6;
  border: none;
  cursor: pointer;
}

.item_action button {
  padding: 12px 18px;
  border-radius: 8px;
  background: #F6F6F6;
  font-size: 18px;
  border: none;
  cursor: pointer;
  transition: background-color ease-in-out 0.3s;
}
.item_action button:hover {
  background-color: #F23969;
}

td {
  text-align: center;
}
td:nth-child(1) {
  text-align: left;
}

.cart_title th {
  padding: 0 60px;
}
@media (max-width: 1135px) {
  .cart_title th {
    padding: 0 35px;
  }
}
@media (max-width: 996px) {
  .cart_title th {
    padding: 0 17px;
  }
}

@media (max-width: 996px) {
  th:nth-child(5) {
    padding: 0;
  }
  .cart_table-section {
    max-width: 92%;
    margin: 0 auto;
  }
}
.cart_btn-group {
  display: flex;
  justify-content: flex-end;
  gap: 32px;
  width: 88%;
}
@media (max-width: 1310px) {
  .cart_btn-group {
    width: 96%;
  }
}
@media (max-width: 960px) {
  .cart_btn-group {
    width: 100%;
  }
}
@media (max-width: 620px) {
  .cart_btn-group {
    align-items: center;
    justify-content: center;
    padding: 0;
    margin-top: 20px;
    gap: 20px;
  }
}
.cart_btn-group button {
  padding: 10px 25px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}
@media (max-width: 500px) {
  .cart_btn-group button {
    font-size: 20px;
  }
}
.cart_btn-group .cart_cancel {
  color: #8E8E8E;
  border: 1px solid #C2C2C2;
  background: #fff;
}
.cart_btn-group .cart_buy {
  background: #B0D404;
  color: #fff;
  border: none;
}

.cart_table-md {
  display: none;
}

@media (max-width: 890px) {
  .item_img {
    padding: 10px;
  }
  .cart_table-md {
    display: block;
    max-width: 100%;
    margin: 0 auto;
  }
  .table_md-item {
    border-bottom: 1px solid #cdcdcd;
    padding-bottom: 40px;
  }
  .table_md-item h4 {
    color: #000;
    font-size: 16px;
    letter-spacing: 0.8px;
    text-transform: capitalize;
    margin: 15px 0;
  }
  .table_md-item .md_item-desc {
    display: flex;
    align-items: flex-start;
    gap: 15px;
  }
}
@media (max-width: 890px) and (max-width: 620px) {
  .table_md-item .md_item-desc {
    flex-direction: column;
    align-items: center;
  }
}
@media (max-width: 890px) {
  .table_md-item .md_item-desc p {
    color: #000;
    font-size: 18px;
    letter-spacing: 0.8px;
    text-transform: capitalize;
  }
  .table_md-item .md_item-desc .md_item-title {
    width: 264px;
  }
  .table_md-item .md_item-desc .md_item-title .item_img {
    width: 264px;
    height: 259px;
    padding: 20px;
    border-radius: 16px;
    background: #F8F8F8;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
@media (max-width: 890px) and (max-width: 620px) {
  .table_md-item .md_item-desc .md_item-title .item_img {
    width: 100%;
    height: 100%;
    padding: 20px;
  }
}
@media (max-width: 890px) {
  .table_md-item .md_item-desc .md_item-title .item_img img {
    max-width: 100%;
    object-fit: cover;
  }
  .table_md-item .md_item-desc .md_item-title .md_item-text {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    margin: 22px 0;
  }
  .table_md-item .md_item-desc .md_item-title .md-item-price {
    color: #F23969;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.8px;
    text-transform: uppercase;
  }
  .table_md-item .md_item-desc .md_item-title .md-item-price span {
    color: #939393;
    letter-spacing: 0.8px;
    text-decoration-line: line-through;
    text-transform: uppercase;
    margin-right: 25px;
  }
  .md_item-info {
    display: flex;
    gap: 35px;
    align-items: center;
  }
  .md_item-info .md_quantity,
  .md_item-info .md_subtitle,
  .md_item-info .md_delivery-date,
  .md_item-info .md_action {
    gap: 50px;
    display: flex;
    align-items: center;
  }
  .md_item-info .md_item-title-info {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }
}
@media (max-width: 890px) and (max-width: 620px) {
  .md_item-info .md_item-title-info {
    gap: 20px;
  }
}
@media (max-width: 890px) {
  .md_item-info .md_item-title-subtotal {
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 0.9px;
    text-transform: uppercase;
  }
  .md_item-info .md_item-title-date input {
    padding: 15px;
    border-radius: 8px;
    background: #F6F6F6;
    font-size: 15px;
    border: none;
  }
  .md_item-info .md_item-title-action button {
    padding: 12px 18px;
    border-radius: 8px;
    background: #F6F6F6;
    font-size: 18px;
    border: none;
    cursor: pointer;
  }
}
.md_item-title-quantity button {
  padding: 0 12px;
  border-radius: 8px;
  background: #F2F2F2;
  border: none;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.md_item-title-quantity .item_quantityCount {
  margin: 0 10px;
  font-size: 20px;
}

@media (max-width: 768px) {
  .responsiveTable td .tdBefore {
    display: block !important;
  }
  .cart_table-section {
    overflow-x: auto;
  }
  .cart_head {
    display: none;
  }
  .cart_title {
    display: block;
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 1;
  }
  .cart_title th {
    padding: 10px;
  }
  .item {
    display: block;
    width: 100%;
    box-sizing: border-box;
  }
  .item td {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    text-align: left;
    padding: 10px;
  }
  .item_description {
    flex-direction: column;
    align-items: flex-start;
  }
  .item_description .item_img {
    width: 100%;
    padding: 15px 0;
  }
  .item_description .item_title {
    padding: 15px 0;
  }
  .item_input {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
  }
  .item_input .btn-group {
    gap: 10px;
  }
  .item_input button {
    padding: 0;
  }
  .item_input .item_quantityCount {
    margin: 0;
  }
  .item_subtotal,
  .item_date,
  .item_action {
    padding: 10px 0;
  }
  .cart_btn-group {
    width: 100%;
    justify-content: center;
  }
}
.input-title {
  background-color: #F8F8F8;
}
.input-title .input-group {
  max-width: 1440px;
  margin: 0 auto;
  padding: 50px 0;
  display: flex;
  flex-direction: column;
  gap: 35px;
}
.input-title .input-group .input-group_items {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  gap: 30px;
}
@media (max-width: 768px) {
  .input-title .input-group .input-group_items {
    flex-direction: column;
    align-items: center;
  }
}
.input-title .input-group .input-group_items .input-inner-group {
  width: 30%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 30px;
}
@media (max-width: 768px) {
  .input-title .input-group .input-group_items .input-inner-group {
    width: 100%;
    padding: 0 5%;
  }
}
.input-title .input-group .input-group_items .input-inner-group .input-item {
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
}
.input-title .input-group .input-group_items .input-inner-group .input-item .label {
  font-family: "Inter", "sans-serif";
  font-size: 15px;
  letter-spacing: 0.75px;
}
.input-title .input-group .input-group_items .input-inner-group .input-item input[type=number]::-webkit-inner-spin-button,
.input-title .input-group .input-group_items .input-inner-group .input-item input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.input-title .input-group .input-group_items .input-inner-group .input-item input[type=number] {
  -moz-appearance: textfield; /* Firefox */
}
.input-title .input-group .input-group_items .input-inner-group .input-item input {
  border-radius: 8px;
  border: 1px solid #CDCDCD;
  background: #FFF;
  padding: 20px 16px;
  outline: none;
}
.input-title .input-group .input-group_items .input-inner-group .input-item input::placeholder {
  color: #7E7E7E;
  font-family: "Inter", "sans-serif";
  font-size: 16px;
  text-transform: capitalize;
}
.input-title .input-group .input-group_items .input-inner-group .input-item textarea {
  padding: 20px 16px;
  border-radius: 8px;
  outline: none;
  resize: none;
  border: 1px solid #CDCDCD;
  height: 100%;
  font-family: "Inter", sans-serif;
}
.input-title .input-group .input-group_items .input-inner-group .input-item textarea::placeholder {
  color: #7E7E7E;
  font-family: "Inter", "sans-serif";
  font-size: 16px;
  text-transform: capitalize;
}

.empty-cart {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  padding: 50px 0;
  min-height: 500px;
}
.empty-cart p {
  color: #958D8D;
  font-size: 24px;
  letter-spacing: 1.2px;
  text-transform: capitalize;
}
.empty-cart svg {
  max-width: 100%;
}

footer {
  background-color: #0B0B0B;
  padding: 50px 0;
  color: #fff;
}
@media (max-width: 500px) {
  footer {
    padding: 50px 0;
  }
}
footer .footer_title {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 30px;
  max-width: 1400px;
  padding: 0 100px;
  margin: 0 auto;
}
@media (max-width: 500px) {
  footer .footer_title {
    padding: 0 20px;
    gap: 20px;
  }
}
@media (max-width: 729px) {
  footer .footer_title {
    justify-content: center;
  }
}
footer .footer_title .social {
  max-width: 250px;
}
footer .footer_title .social .social_logo {
  position: relative;
}
footer .footer_title .social .social_logo .social_link {
  font-size: 18px;
  font-weight: 500;
  line-height: 20px;
  text-transform: uppercase;
}
footer .footer_title .social .social_logo .social_link img {
  width: 83px;
  position: absolute;
  left: -93px;
  top: -10px;
}
@media (max-width: 500px) {
  footer .footer_title .social .social_logo .social_link img {
    right: 0;
    top: 0;
    left: 180px;
  }
}
footer .footer_title .social .social_text {
  margin: 30px 0;
  font-size: 12px;
  line-height: 16px;
}
footer .footer_title .social .social_icons {
  display: flex;
  gap: 20px;
}
@media (max-width: 650px) {
  footer .footer_title .footer-contact {
    width: 250px;
  }
}
footer .footer_title .footer-contact .contact_title {
  font-weight: 500;
  line-height: normal;
  margin-bottom: 30px;
}
footer .footer_title .footer-contact .contact_title::before {
  content: "";
  border-left: 2px solid #B0D404;
  height: 100%;
  width: 2px;
  padding-left: 10px;
}
footer .footer_title .footer-contact li {
  margin-bottom: 15px;
  font-size: 12px;
}
footer .footer_title .footer-contact li::marker {
  color: #F56E91;
  font-size: 14px;
}
footer .footer_title .newsletter {
  max-width: 250px;
}
footer .footer_title .newsletter .newsletter_title {
  font-weight: 500;
  line-height: normal;
  margin-bottom: 30px;
}
footer .footer_title .newsletter .newsletter_title::before {
  content: "";
  border-left: 2px solid #B0D404;
  height: 100%;
  width: 2px;
  padding-left: 10px;
}
footer .footer_title .newsletter .newsletter_text {
  font-size: 12px;
  line-height: 16px;
  margin: 20px 0;
}
footer .footer_title .newsletter .newsletter_input {
  display: flex;
  align-items: center;
  position: relative;
}
footer .footer_title .newsletter .newsletter_input input {
  width: 100%;
  height: 40px;
  background: rgba(188, 188, 188, 0.3);
  color: rgba(228, 228, 228, 0.9);
  border: none;
  border-radius: 25px;
  padding: 0 15px;
  outline: none;
}
@media (max-width: 634px) {
  footer .footer_title .newsletter .newsletter_input input {
    background-color: #BCBCBC;
    color: #2B2B2B;
  }
}
footer .footer_title .newsletter .newsletter_input button {
  position: absolute;
  right: 10px;
  background: transparent;
  border: none;
  cursor: pointer;
}

.form .pass_description {
  width: 100%;
  color: #676767;
  font-size: clamp(0.875rem, 0.8393rem + 0.1786vw, 1rem);
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.8px;
  margin-top: 17px;
  text-align: justify;
}
.form .btn_sign {
  color: #fff;
  border: none;
  height: 50px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  background-color: rgb(245, 110, 145);
  margin-top: 20px;
}

@media (max-width: 610px) {
  .signup_panel {
    width: 100%;
    padding: 20px;
  }
  .signup_panel .form {
    width: 100%;
  }
  .signup_panel .form .labels .input_box input {
    width: 100%;
    padding: 10px;
    margin: 10px 0;
  }
  .signup_panel .form .labels .input_box_pass .pass_eye input {
    width: 100%;
  }
  .signup_panel .form .labels .pass_description {
    width: 100%;
  }
  .signup_panel .form .btn_sign {
    width: 100%;
  }
}
.signIn_panel,
.signup_panel {
  display: flex;
  flex-direction: column;
  padding: 35px 45px;
  border-radius: 16px;
  background: #fff;
  width: 500px;
  max-width: 100%;
}
@media (max-width: 560px) {
  .signIn_panel,
  .signup_panel {
    padding: 20px 25px;
  }
}
.signIn_panel h2,
.signup_panel h2 {
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}
.signIn_panel .form,
.signup_panel .form {
  display: flex;
  margin: 15px 0;
  flex-direction: column;
}
.signIn_panel .form .input-box_title,
.signup_panel .form .input-box_title {
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.8px;
  margin: 20px 0;
}
.signIn_panel .form .singIn-input_error,
.signup_panel .form .singIn-input_error {
  border-color: red;
}
.signIn_panel .form .error-text,
.signup_panel .form .error-text {
  color: red;
  margin: 5px 0 0 15px;
}
.signIn_panel .form .input_box .passEye,
.signup_panel .form .input_box .passEye {
  position: relative;
}
.signIn_panel .form .input_box .passEye .eye,
.signup_panel .form .input_box .passEye .eye {
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
}
.signIn_panel .form .reset_link,
.signup_panel .form .reset_link {
  display: flex;
  justify-content: end;
}
.signIn_panel .form .reset_link p,
.signup_panel .form .reset_link p {
  color: #676767;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.8px;
  margin-top: 17px;
  cursor: pointer;
}
.signIn_panel .form .logIn,
.signup_panel .form .logIn {
  display: flex;
  color: #fff;
  border: none;
  height: 50px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  background-color: rgb(245, 110, 145);
  margin-top: 32px;
}
.signIn_panel .form .logIn:hover,
.signup_panel .form .logIn:hover {
  background-color: #f56e91;
}
.signIn_panel .text-input,
.signup_panel .text-input {
  display: flex;
  width: 100%;
  height: 50px;
  padding: 10px 20px;
  border-radius: 8px;
  border: 1px solid #a2a2a2;
  color: rgb(0, 0, 0);
  outline: none;
  font-size: 18px;
}
.signIn_panel .text-input_error,
.signup_panel .text-input_error {
  border-color: red;
}
.signIn_panel .line,
.signup_panel .line {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.signIn_panel .line hr,
.signup_panel .line hr {
  width: 170px;
  height: 1px;
  color: rgb(162, 162, 162);
}
.signIn_panel .line .or,
.signup_panel .line .or {
  display: flex;
  width: 35px;
  height: 27px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #a2a2a2;
  color: rgb(162, 162, 162);
  padding: 0 30px;
}
.signIn_panel .icons_ul,
.signup_panel .icons_ul {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  gap: 40px;
  list-style: none;
}
.signIn_panel .icons_ul .icons_url,
.signup_panel .icons_ul .icons_url {
  cursor: pointer;
}
.signIn_panel .signIn_footer p,
.signup_panel .signIn_footer p {
  color: #676767;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.8px;
  margin-top: 20px;
  text-align: center;
}
.signIn_panel .signIn_footer p span,
.signup_panel .signIn_footer p span {
  text-decoration-line: underline;
  cursor: pointer;
  text-transform: uppercase;
}

@media (max-width: 610px) {
  .singIn_panel {
    padding: 30px;
  }
  .singIn_panel .form .input_box input {
    width: 100%;
  }
  .singIn_panel .form .input_box_pass .passEye input {
    width: 100%;
  }
  .singIn_panel .icons .line hr {
    width: 100%;
  }
}
.reset {
  padding: 35px 40px;
  border-radius: 16px;
  background: #fff;
  width: 500px;
  max-width: 100%;
}
.reset .reset_title {
  display: flex;
  align-items: center;
  gap: 20px;
}
.reset .reset_title .reset_title-arrow {
  cursor: pointer;
}
.reset .reset_title h2 {
  font-size: clamp(1.0625rem, 0.9375rem + 0.625vw, 1.5rem);
  font-weight: 700;
  letter-spacing: 1.2px;
}
.reset .input_box {
  display: flex;
  flex-direction: column;
  margin: 25px 0;
}
.reset .input_box .reset_title {
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.8px;
  margin-bottom: 11px;
}
.reset .input_box .input-box {
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
  gap: 10px;
}
.reset .input_box .input-box .input_reset {
  width: 100%;
  display: flex;
  height: 50px;
  padding: 10px 20px;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #a2a2a2;
}
.reset .input_box .input-box .input_reset-error {
  border-radius: 8px;
  border-color: red;
}
.reset .input_box .input-box .reset-error {
  color: red;
}
.reset .input_box .btn_reset {
  display: flex;
  height: 50px;
  padding: 10px 20px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: #f56e91;
  border: none;
  cursor: pointer;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  width: 100%;
}
P .reset .input_box .btn_reset:hover {
  background-color: rgb(236, 127, 156);
}

@media (max-width: 610px) {
  .reset {
    padding: 30px;
  }
  .reset .input_box {
    margin: 20px 0;
  }
  .reset .input_box .input_reset {
    width: 100%;
  }
  .reset .input_box .btn_reset {
    width: 100%;
  }
}
.sign-out {
  padding: 22px 25px;
  border-radius: 16px;
  border: 1px solid #b8b8b8;
  background: #fff;
  width: 500px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.sign-out .log-out {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.sign-out .log-out h4 {
  color: #000;
  font-size: 22px;
  font-weight: 700;
  text-transform: capitalize;
}
.sign-out .log-out span {
  font-size: 22px;
  cursor: pointer;
}
.sign-out .sign-out_text {
  font-size: 16px;
  font-weight: 400;
}
.sign-out .input_box {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}
@media (max-width: 400px) {
  .sign-out .input_box {
    flex-wrap: wrap;
  }
}
.sign-out .sign-out_btn {
  background-color: #B0D404;
  color: #fff;
  width: 100%;
  font-weight: 500;
  font-size: 16px;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid #B0D404;
}
.sign-out .cancel-btn {
  background-color: #fff;
  color: #000;
  border: 1px solid #B0D404;
  transition: all ease-in-out 0.2s;
}
.sign-out .cancel-btn:hover {
  background-color: #B0D404;
  color: #FFFFFF;
}

.ReactModal__Overlay.ReactModal__Overlay--after-open {
  background: rgba(0, 0, 0, 0.7) !important;
  z-index: 100;
}
@media (max-width: 609px) {
  .ReactModal__Overlay.ReactModal__Overlay--after-open {
    padding: 0;
  }
}
@media (max-width: 609px) {
  .ReactModal__Overlay.ReactModal__Overlay--after-open .ReactModal__Content.ReactModal__Content--after-open {
    inset: 0;
    justify-content: center;
    width: 90%;
  }
}
.ReactModal__Overlay.ReactModal__Overlay--after-open .ReactModal__Content.ReactModal__Content--after-open .auth-modal-content {
  width: 500px;
}
@media (max-width: 609px) {
  .ReactModal__Overlay.ReactModal__Overlay--after-open .ReactModal__Content.ReactModal__Content--after-open .auth-modal-content {
    width: 100%;
  }
}

.contact {
  display: flex;
  justify-content: center;
  gap: 100px;
  max-width: 1440px;
  margin: 0 auto;
  padding: 100px 15px;
}
@media (max-width: 998px) {
  .contact {
    gap: 30px;
    flex-wrap: wrap;
  }
}
.contact .contact_container {
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
  gap: 40px;
  padding: 65px 50px;
  background-color: #F8F8FA;
  max-width: 600px;
}
@media (max-width: 998px) {
  .contact .contact_container {
    max-width: 100%;
    padding: 25px 15px;
    gap: 20px;
  }
}
.contact .contact_container .contact_title {
  font-size: 24px;
  font-weight: normal;
}
.contact .contact_container .contact_text {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.contact .contact_container .contact_text .text {
  color: #707070;
  font-size: 16px;
  line-height: 28px;
  text-align: justify;
}
@media (max-width: 610px) {
  .contact .contact_container .contact_text .text {
    font-size: 14px;
  }
}
.contact .form_container {
  width: 100%;
}
.contact .form_container .form_title {
  font-size: 26px;
  font-weight: 400;
}
.contact .form_container .form_message {
  display: flex;
  flex-direction: column;
  gap: 50px;
  margin-top: 50px;
}
.contact .form_container .form_message .labels {
  display: flex;
  align-items: center;
  gap: 50px;
}
@media (max-width: 610px) {
  .contact .form_container .form_message .labels {
    flex-wrap: wrap;
    gap: 20px;
  }
}
.contact .form_container .form_message .labels .labels-inner {
  display: flex;
  flex-direction: column;
  width: clamp(12.5rem, -1.612rem + 22.6244vw, 18.75rem);
}
@media (max-width: 998px) {
  .contact .form_container .form_message .labels .labels-inner {
    width: 100%;
  }
}
.contact .form_container .form_message .labels .labels-inner p {
  color: #666;
  font-size: 16px;
}
@media (max-width: 480px) {
  .contact .form_container .form_message .labels .labels-inner p {
    font-size: 14px;
  }
}
.contact .form_container .form_message .labels .labels-inner input, .contact .form_container .form_message .labels .labels-inner textarea {
  border: none;
  border-bottom: 1px solid #808080;
  outline: none;
  padding: 15px 10px 5px 5px;
}
.contact .form_container .form_message .labels .labels-inner textarea {
  height: 120px;
  resize: none;
}
@media (max-width: 610px) {
  .contact .form_container .form_message .labels .labels-inner textarea {
    height: 120px;
    font-size: 12px;
  }
}
.contact .form_container .form_message .labels .labels-inner select {
  display: flex;
  flex-direction: column;
  width: 100%;
  border: none;
  background: transparent;
  border-bottom: 1px solid #808080;
  padding: 15px 10px 5px 5px;
  outline: none;
}
.contact .form_container .form_message .labels .labels-inner.textarea {
  width: 100% !important;
}
.contact .form_container .form-button {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
@media (max-width: 610px) {
  .contact .form_container .form-button {
    justify-content: center;
  }
}
.contact .form_container .form-button .btn_message {
  background-color: #B0D404;
  border-radius: 8px;
  padding: 10px 24px;
  border: none;
  color: #fff;
  font-size: 22px;
  font-weight: 500;
  cursor: pointer;
}

.not-found {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 30px;
  padding: 20px 15px;
}
.not-found .not-fount_text {
  font-size: clamp(1.125rem, 0.9464rem + 0.8929vw, 1.75rem);
  font-weight: 500;
  letter-spacing: 1.4px;
  text-align: center;
}
.not-found button {
  border-radius: 8px;
  background: #B0D404;
  padding: 10px 50px;
  color: #fff;
  border: none;
  font-size: 22px;
  font-weight: 700;
  cursor: pointer;
  text-transform: capitalize;
}

.user-table_image {
  width: 80px;
}

.slides-box {
  background-color: #fff;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 15px;
  width: 100%;
}

.add-image {
  width: 210px;
}

.all-images {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 0 20px;
}
@media (max-width: 490px) {
  .all-images {
    justify-content: center;
  }
}
.all-images .slide-image {
  width: 210px;
  height: 195px;
  border: 1px solid #CDCDCD;
  border-radius: 10px;
  position: relative;
}
@media (max-width: 490px) {
  .all-images .slide-image {
    width: 100%;
    height: auto;
  }
}
.all-images .slide-image img {
  width: 210px;
  height: 195px;
  object-fit: cover;
  padding: 20px;
}
@media (max-width: 490px) {
  .all-images .slide-image img {
    width: 100%;
  }
}
.all-images .slide-image button {
  position: absolute;
  top: 0px;
  right: -5px;
  border: none;
  background: transparent;
  cursor: pointer;
}

.image-frame {
  max-width: 100%;
  height: 90px;
  border: 1px solid #CDCDCD;
  border-radius: 10px;
  position: relative;
}
@media (max-width: 400px) {
  .image-frame {
    max-width: 100%;
    width: 100%;
  }
}
.image-frame .preview-img {
  max-width: 100%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  padding: 10px;
}
.image-frame .input-img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
}
.image-frame .input-img p {
  color: #3963AD;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
}
.image-frame .input-img input {
  display: none;
}

.image-for-preview {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  flex-direction: column;
}
.image-for-preview .edit-images {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}
.image-for-preview .edit-images .add-edit-images {
  position: relative;
}
.image-for-preview .edit-images .add-edit-images img {
  width: 150px;
  height: 120px;
  object-fit: cover;
  position: relative;
}
.image-for-preview .edit-images .add-edit-images span {
  position: absolute;
  top: 0;
  right: 0;
  color: red;
  cursor: pointer;
}

.admin-navigation {
  background: #041737;
  position: relative;
  cursor: pointer;
  transition: width 0.3s ease-in-out;
}
.admin-navigation .admin-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transition: all ease-in-out 0.6s;
}
.admin-navigation .admin-logo .logo {
  width: 120px;
}
.admin-navigation .admin-logo h5 {
  color: #fff;
  display: block;
  margin-top: 15px;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  margin-bottom: 100px;
}
.admin-navigation .admin-nav-link {
  display: flex;
  flex-direction: column;
  margin: 0 20px;
  gap: 15px;
  transition: all ease-in-out 0.3s;
}
.admin-navigation .admin-nav-link a {
  color: #79A3D6;
  font-size: 16px;
  font-weight: 400;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 10px 15px;
  transition: all ease-in-out 0.2s;
}
.admin-navigation .admin-nav-link a:hover {
  border-radius: 10px;
  background: #3963AD;
  color: #fff;
}
.admin-navigation .admin-nav-link a svg {
  font-size: 30px;
}
.admin-navigation .admin-nav-link .active {
  border-radius: 10px;
  background: #3963AD;
  color: #fff;
}

.logOut {
  border: none;
  background: transparent;
  color: #fff;
  font-size: 25px;
  text-transform: uppercase;
  text-align: center;
  width: 100%;
  margin-top: 50px;
  cursor: pointer;
  padding: 10px 15px;
  border-radius: 10px;
  transition: all ease-in-out 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.logOut:hover {
  background-color: rgba(255, 255, 255, 0.3);
}
.logOut svg {
  font-size: 30px;
}

.admin-navigation {
  width: 270px;
  transition: all ease-in-out 0.2s;
}
.admin-navigation .open-sidebar {
  position: absolute;
  right: -5px;
  cursor: pointer;
}
.admin-navigation .open-sidebar svg {
  color: #fff;
  font-size: 40px;
}

.open {
  width: 120px;
  transition: all ease-in-out 0.2s;
}
.open .close-sidebar {
  position: absolute;
  right: -5px;
  cursor: pointer;
}
.open .close-sidebar svg {
  color: #fff;
  font-size: 40px;
  text-align: center;
}
.open .admin-nav-link {
  transition: all ease-in-out 0.2s;
}
.open .admin-nav-link a {
  display: block;
  text-align: center;
  padding: 10px 0;
}

.admin-body {
  display: flex;
  background: #F0F1F3;
  width: 100%;
  height: 100%;
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/mainIcons.scss","webpack://./src/assets/styles/main.scss","webpack://./src/assets/styles/header.scss","webpack://./src/assets/styles/variables.scss","webpack://./src/assets/styles/slider.scss","webpack://./src/assets/styles/categories.scss","webpack://./src/assets/styles/contact.scss","webpack://./src/assets/styles/about.scss","webpack://./src/assets/styles/products.scss","webpack://./src/assets/styles/productItem.scss","webpack://./src/assets/styles/navigateSection.scss","webpack://./src/assets/styles/whoWeAre.scss","webpack://./src/assets/styles/discount.scss","webpack://./src/assets/styles/ourProducts.scss","webpack://./src/assets/styles/specialOrder.scss","webpack://./src/assets/styles/ourPartners.scss","webpack://./src/assets/styles/ourClientOpinion.scss","webpack://./src/assets/styles/slidePrevBtn.scss","webpack://./src/assets/styles/slideNextBtn.scss","webpack://./src/assets/styles/categoriesItem.scss","webpack://./src/assets/styles/payment.scss","webpack://./src/assets/styles/cart.scss","webpack://./src/assets/styles/footer.scss","webpack://./src/assets/styles/signUp.scss","webpack://./src/assets/styles/signIn.scss","webpack://./src/assets/styles/resetPass.scss","webpack://./src/assets/styles/authModal.scss","webpack://./src/assets/styles/contactUs.scss","webpack://./src/assets/styles/notFound.scss","webpack://./src/assets/adminStyles/user/users.scss","webpack://./src/assets/adminStyles/slides/slides.scss","webpack://./src/assets/adminStyles/adminNavigation.scss","webpack://./src/assets/adminStyles/adminDashboard.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;ACGF;ADDE;;;EAGE,kBAAA;ACGJ;ADAE;EACE,eAAA;ACEJ;ADCE;;EAEE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ACCJ;;AChCA;EACE,sBAAA;EACA,SAAA;EACA,UAAA;ADmCF;;AChCA;EACE,+BCPW;EDQX,eAAA;ADmCF;;AC/BA;EACE,YAAA;ADkCF;;AC9BA;EACE,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gCAAA;ADiCF;AC/BE;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;ADiCJ;AC/BI;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;ADiCN;AC/BM;EALF;IAMI,aAAA;EDkCN;AACF;AC/BI;EACE,YAAA;EACA,eAAA;ADiCN;AC7BE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,YAAA;AD+BJ;AC9BI;EANF;IAOI,6BAAA;EDiCJ;AACF;AC9BM;EACE,eAAA;EACA,gBAAA;EACA,2DAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,6BAAA;ADgCR;AC9BQ;EACE,+BAAA;EACA,8BAAA;ADgCV;AC5BM;EACE,WAAA;AD8BR;AC1BI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sDAAA;EACA,gBAAA;AD4BN;AC1BM;EAPF;IAQI,SAAA;ED6BN;AACF;AC1BI;EACE,aAAA;EACA,SAAA;AD4BN;AC3BM;EAHF;IAII,aAAA;ED8BN;AACF;AC5BM;EACE,WAAA;EACA,gCAAA;EACA,kBAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;AD8BR;AC5BQ;EACE,WAAA;AD8BV;AC3BQ;EACE,cAAA;AD6BV;AC1BQ;EACE,cAAA;AD4BV;ACpBI;EACE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,aAAA;EACA,YAAA;EACA,qCAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;ADsBN;ACpBM;EAfF;IAgBI,aAAA;EDuBN;AACF;ACrBM;EACE,eAAA;EACA,0DAAA;EACA,gBAAA;EACA,WAAA;EACA,gCAAA;ADuBR;ACtBQ;EANF;IAOI,UAAA;EDyBR;AACF;ACvBQ;EACE,WAAA;ADyBV;ACtBQ;EACE,cAAA;ADwBV;ACrBQ;EACE,cAAA;ADuBV;;ACbA;EACE,WAAA;EACA,aAAA;ADgBF;ACfE;EAHF;IAII,cAAA;EDkBF;AACF;AChBE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;ADkBJ;AChBI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,wBAAA;ADkBN;ACdI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,wBAAA;ADgBN;ACbI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,wBAAA;ADeN;ACXE;EACE,WAAA;EACA,WAAA;EACA,aAAA;ADaJ;ACVE;EAGE,4DAAA;EACA,yBAAA;ADYJ;ACTE;EAGE,2DAAA;EACA,yBAAA;ADWJ;ACPE;EACE,oBAAA;EACA,sBAAA;EACA,yBAAA;ADSJ;;AGzPE;EACE,uBAAA;AH4PJ;AGvPI;;EAEE,gBAAA;EACA,WAAA;AHyPN;AGrPI;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AHuPN;AGtPM;EALF;IAMI,WAAA;EHyPN;AACF;AGvPM;EACE,eAAA;EACA,YAAA;EACA,2BAAA;EACA,iBAAA;AHyPR;AGvPQ;EANF;IAOI,aAAA;EH0PR;AACF;AGvPM;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mDAAA;AHyPR;AGvPQ;EACE,+BD3CG;EC4CH,WAAA;EACA,yDAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;AHyPV;AGrPQ;EACE,8BAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EAEA,mBAAA;EACA,gBAAA;AHsPV;AGrPU;EARF;IASI,YAAA;EHwPV;AACF;AGtPU;EACE,cAAA;EACA,+BDlEC;ECmED,uDAAA;EACA,gBAAA;EAEA,yBAAA;AHuPZ;AGnPQ;EACE,uDAAA;EACA,uDAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,yBAAA;EACA,SAAA;AHqPV;AGpPU;EATF;IAUI,WAAA;EHuPV;AACF;AGpPU;EACE,WAAA;EACA,+BD1FC;EC2FD,2DAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;AHsPZ;AGpPY;EACE,cAAA;EACA,WAAA;EACA,sDAAA;EACA,gBAAA;AHsPd;;AI1VA;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;AJ6VF;AI3VE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AJ6VJ;AI5VI;EALF;IAMI,sBAAA;EJ+VJ;AACF;AI7VI;EACE,eAAA;EACA,YAAA;EACA,wDAAA;EACA,iBAAA;AJ+VN;AIvVI;EACE,2DAAA;AJyVN;AIxVM;EAFF;IAGI,yDAAA;EJ2VN;AACF;AIzVM;EACE,uDAAA;AJ2VR;;AK5XA;EACE,eAAA;AL+XF;AK9XE;EAFF;IAGI,mBAAA;ELiYF;AACF;AK/XE;EACE,aAAA;EACA,6BAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;ALiYJ;AKhYI;EAPF;IAQI,SAAA;ELmYJ;AACF;AKlYI;EAVF;IAWI,iBAAA;IACA,cAAA;IACA,aAAA;ELqYJ;AACF;AKpYI;EAfF;IAgBI,aAAA;ELuYJ;AACF;AKrYI;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;ALuYN;AKrYM;EANF;IAOI,WAAA;IACA,mBAAA;IACA,mBAAA;ELwYN;AACF;AKvYM;EAXF;IAYI,sBAAA;EL0YN;AACF;AKxYM;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;AL0YR;AKzYQ;EANF;IAOI,aAAA;EL4YR;AACF;AK1YQ;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,SAAA;AL4YV;AK1YU;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;AL4YZ;AKzYU;EACE,cAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AL2YZ;AKxYU;EACE,cAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AL0YZ;AKrYQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;ALuYV;AKnYQ;EACE,cAAA;ALqYV;AKlYQ;EACE,cAAA;ALoYV;AK/XM;EACE,WAAA;EACA,gCAAA;EACA,eAAA;EACA,iBAAA;ALiYR;AK5XE;EACE,uBAAA;EACA,UAAA;AL8XJ;AK5XI;EAJF;IAKI,WAAA;EL+XJ;AACF;AK3XM;EADF;IAEI,qBAAA;EL8XN;AACF;AK3XI;EACE,uBAAA;AL6XN;AKzXI;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AL2XN;AKzXM;EACE,eAAA;EACA,YAAA;AL2XR;AKxXM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;AL0XR;AKxXQ;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;AL0XV;AKvXQ;EACE,WAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;ALyXV;AKtXQ;EACE,WAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ALwXV;;AMniBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;ANsiBF;AMniBE;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;ANqiBJ;;AOljBA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;APqjBF;AOljBE;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;APojBJ;AOljBI;EARF;IASI,uBAAA;EPqjBJ;AACF;AOljBI;EACE,gBAAA;EACA,qBAAA;APojBN;AOxiBM;EACE,aAAA;EACA,mDAAA;EACA,gBAAA;AP0iBR;AOxiBQ;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;AP0iBV;AOxiBU;EACE,cAAA;AP0iBZ;AOpiBI;EACE,kBAAA;APsiBN;AOpiBM;EACE,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,sDAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;APsiBR;AOniBM;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;APqiBR;;AO7hBA;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;APgiBF;;AO7hBA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,oBAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;APgiBF;AO9hBE;EATF;IAUI,gBAAA;EPiiBF;AACF;;AO9hBA;EACE,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EAEA,aAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;APgiBF;AO9hBE;EACE,aAAA;EACA,sBAAA;EACA,6BAAA;EAEA,gBAAA;EACA,SAAA;AP+hBJ;AO5hBE;EACE,aAAA;AP8hBJ;AO1hBE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AP4hBJ;AOzhBE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AP2hBJ;AOzhBI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;AP2hBN;AOxhBI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AP0hBN;;AOrhBA;EACE,aAAA;EACA,6BAAA;EACA,SAAA;EACA,mBAAA;APwhBF;;AOrhBA;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;APwhBF;;AO9gBA;EACE,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;APihBF;;AO5gBA;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AP+gBF;;AO5gBA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AP+gBF;;AOzgBA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AP4gBF;AOzgBI;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AP2gBN;AOzgBM;EACE,eAAA;AP2gBR;AOvgBI;EACE,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;APygBN;;AOngBA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;APsgBF;;AOngBA;EACE,kBAAA;APsgBF;AOpgBE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,gCAAA;EACA,QAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;APsgBJ;AOpgBI;EACE,WAAA;EACA,gCAAA;EACA,qDAAA;APsgBN;AOngBI;EACE,cAAA;EACA,8BAAA;EACA,yDAAA;APqgBN;;AQ/xBA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,iEAAA;EACA,iBAAA;EACA,cAAA;ARkyBF;AQjyBE;EAPF;IAQI,sBAAA;ERoyBF;AACF;AQjyBE;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;ARmyBJ;AQlyBI;EANF;IAOI,sBAAA;IACA,YAAA;ERqyBJ;AACF;AQlyBI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,wDAAA;ARoyBN;AQnyBM;EAPF;IAQI,WAAA;ERsyBN;AACF;AQpyBM;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;ARsyBR;AQryBQ;EANF;IAOI,sDAAA;IACA,0DAAA;ERwyBR;AACF;AQtyBQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;ARwyBV;AQpyBM;EACE,wDAAA;EACA,eAAA;ARsyBR;AQryBQ;EAHF;IAII,WAAA;ERwyBR;AACF;;AQjyBA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mDAAA;ARoyBF;AQnyBE;EALF;IAMI,cAAA;IACA,kBAAA;ERsyBF;AACF;AQpyBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ARsyBJ;AQnyBE;;EAEE,aAAA;EACA,sBAAA;EACA,oDAAA;ARqyBJ;AQlyBE;EACE,aAAA;EACA,mBAAA;ARoyBJ;AQhyBI;EACE,WAAA;EACA,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;ARkyBN;AQjyBM;EARF;IASI,yDAAA;ERoyBN;AACF;AQjyBI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,mBAAA;ARmyBN;AQ/xBE;EACE,aAAA;EACA,SAAA;ARiyBJ;AQhyBI;EAHF;IAII,uBAAA;ERmyBJ;AACF;AQjyBI;EACE,eAAA;EACA,sBAAA;EACA,yBAAA;ARmyBN;AQhyBI;EACE,cAAA;EACA,kCAAA;ARkyBN;AQ/xBI;EACE,cAAA;EACA,gBAAA;ARiyBN;;AQ5xBA;EAEE,kBAAA;AR8xBF;AQ7xBE;EAHF;IAII,cAAA;IACA,YAAA;ERgyBF;AACF;AQ/xBE;EAPF;IAQI,cAAA;IACA,YAAA;ERkyBF;AACF;AQjyBE;EAXF;IAYI,cAAA;IACA,YAAA;ERoyBF;AACF;AQlyBE;EAhBF;IAiBI,aAAA;ERqyBF;AACF;AQnyBE;EAEE,kBAAA;ARoyBJ;AQnyBI;EAHF;IAII,eAAA;ERsyBJ;AACF;AQryBI;EANF;IAOI,WAAA;ERwyBJ;AACF;AQ7xBI;EAGE,uBAAA;EACA,YAAA;AR6xBN;AQ1xBI;EACE,gCAAA;AR4xBN;AQzxBI;;EAEE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AR2xBN;AQvxBI;EACE,UAAA;EACA,SAAA;EACA,UAAA;EACA,gCAAA;ARyxBN;AQxxBM;EALF;IAMI,QAAA;IACA,uBAAA;IACA,8CAAA;ER2xBN;AACF;AQ1xBM;EAVF;IAWI,QAAA;IACA,uBAAA;IACA,8CAAA;ER6xBN;AACF;AQxxBI;EACE,sBAAA;EACA,SAAA;EACA,UAAA;EACA,gCAAA;AR0xBN;AQzxBM;EALF;IAMI,WAAA;IACA,8CAAA;IACA,QAAA;ER4xBN;AACF;AQ3xBM;EAVF;IAWI,WAAA;IACA,8CAAA;IACA,QAAA;ER8xBN;AACF;AQzxBE;EACE,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;AR2xBJ;AQzxBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AR2xBN;;AS5hCA;EACE,aAAA;EACA,SAAA;EACA,+DAAA;EACA,eAAA;AT+hCF;AS9hCE;EALF;IAMI,aAAA;ETiiCF;AACF;AS9hCE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;ATgiCJ;AS7hCE;EACE,cAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;AT+hCJ;;AS3hCA;EACE,WAAA;EACA,gCAAA;EACA,yDAAA;EACA,gBAAA;EACA,sEAAA;EACA,gCAAA;AT8hCF;;AS3hCA;EACE,eAAA;EACA,aAAA;EACA,kBAAA;AT8hCF;AS7hCE;EAJF;IAKI,aAAA;ETgiCF;AACF;AS9hCE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;ATgiCJ;AS9hCI;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,qBAAA;ATgiCN;AS5hCE;EACE,WAAA;EACA,YAAA;EACA,oCAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;AT8hCJ;AS3hCE;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;AT6hCJ;AS5hCI;EAXF;IAYI,eAAA;ET+hCJ;AACF;;AU/mCA;EAEE,kBAAA;AVinCF;AU/mCE;EACE,kBAAA;EACA,UAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AVinCJ;AU/mCI;EACE,WAAA;EACA,eAAA;AVinCN;AU7mCE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sDAAA;EACA,eAAA;EACA,yDAAA;EACA,4DAAA;EACA,kBAAA;AV+mCJ;AU7mCI;EACE,aAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AV+mCN;AU9mCM;EANF;IAOI,UAAA;EVinCN;AACF;AU/mCM;EACE,8BAAA;EACA,gCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,MAAA;EACA,QAAA;AVinCR;AU9mCM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;AVgnCR;AU7mCM;EACE,eAAA;EACA,WAAA;EACA,UAAA;AV+mCR;AU9mCQ;EAJF;IAKI,eAAA;EVinCR;AACF;AU7mCI;EACE,wDAAA;EACA,eAAA;EACA,UAAA;AV+mCN;AU9mCM;EAJF;IAKI,UAAA;EVinCN;AACF;AUhnCM;EAPF;IAQI,WAAA;EVmnCN;AACF;AUhnCQ;EACE,cAAA;EACA,gCAAA;EACA,oDAAA;EACA,gBAAA;EACA,mBAAA;AVknCV;AU/mCQ;EACE,cAAA;EACA,gCAAA;EACA,sDAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AVinCV;AU9mCQ;EACE,iBAAA;EACA,8BAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,gCAAA;EACA,wDAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AVgnCV;AU/mCU;EAXF;IAYI,cAAA;EVknCV;AACF;;AWluCA;EACE,kBAAA;AXquCF;AWnuCE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AXquCJ;AWpuCI;EAJF;IAKI,aAAA;EXuuCJ;AACF;AWnuCE;EACE,kBAAA;EACA,MAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AXquCJ;AWpuCI;EAPF;IAQI,kBAAA;EXuuCJ;AACF;AWruCI;EACE,cAAA;EACA,+BT1BO;ES2BP,wDAAA;EACA,gBAAA;AXuuCN;AWpuCI;EACE,4BAAA;EACA,+BTjCO;ESkCP,oDAAA;EACA,gBAAA;AXsuCN;;AYzwCA;EACE,eAAA;AZ4wCF;AYnwCA;EACE,aAAA;EAEA,SAAA;AZowCF;AYlwCE;EALF;IAOI,sBAAA;IACA,gBAAA;IACA,eAAA;EZowCF;AACF;AYjwCE;EAGE,aAAA;AZiwCJ;AY/vCI;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AZiwCN;AYhwCM;EAJF;IAKI,aAAA;IACA,eAAA;EZmwCN;AACF;;AY7vCA;EACE,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,UAAA;AZgwCF;AY7vCE;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,UAAA;AZ+vCJ;AY5vCE;EACE,YAAA;AZ8vCJ;AY1vCI;EACE,QAAA;EACA,WAAA;EACA,2BAAA;AZ4vCN;AYxvCE;EACE,kBAAA;EACA,gCAAA;AZ0vCJ;AYvvCE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,sDAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,0BAAA;EACA,QAAA;EACA,gCAAA;AZyvCJ;AYxvCI;EAhBF;IAiBI,yBAAA;IACA,kBAAA;IACA,yDAAA;EZ2vCJ;AACF;AYzvCI;EACE,kDAAA;AZ2vCN;;Aaj2CA;EACE,WAAA;EACA,gCAAA;EACA,0DAAA;EACA,kBAAA;EACA,kBAAA;EAEA,qBAAA;EACA,gBAAA;Abm2CF;Aal2CE;EATF;IAUI,kBAAA;IACA,WAAA;IACA,eAAA;Ebq2CF;AACF;Aal2CE;EACE,WAAA;EACA,cAAA;EACA,wDAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,gCAAA;Abo2CJ;;Aa/1CE;EACE,gBAAA;EACA,aAAA;EACA,oBAAA;Abk2CJ;Aa51CI;EACE,eAAA;Ab81CN;Aa51CQ;EACE,aAAA;EACA,mBAAA;Ab81CV;Aa51CU;EACE,eAAA;Ab81CZ;Aaz1CI;EACE,aAAA;Ab21CN;;Acj5CA;EACI,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;Ado5CJ;;Acl5CA;EACI,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,wBAAA;EACA,uBAAA;EACA,mBAAA;Adq5CJ;Acp5CI;EAPJ;IAQQ,sBAAA;Edu5CN;AACF;;Ae16CA;EACE,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;Af66CF;Aez6CI;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;Af26CN;Aex6CQ;EACE,YAAA;Af06CV;Aer6CI;EACE,6BAAA;Afu6CN;Aen6CE;;EAEE,qBAAA;Afq6CJ;Ael6CE;EACE,WAAA;EACA,kBAAA;EACA,+BbvCS;EawCT,wDAAA;EACA,0BAAA;EACA,eAAA;Afo6CJ;Aej6CE;EACE,UAAA;EACA,gBAAA;Afm6CJ;Ae75CM;EACE,UAAA;EACA,eAAA;EACA,cAAA;Af+5CR;Ae95CQ;EAJF;IAKI,WAAA;Efi6CR;AACF;Ae/5CQ;EACE,WAAA;EACA,+Bb/DG;EagEH,eAAA;EACA,iBAAA;Afi6CV;Ae95CQ;EACE,2DAAA;Afg6CV;Ae75CQ;EACE,gBAAA;Af+5CV;;AgBv+CI;EACI,sBAAA;AhB0+CR;;AiB3+CI;EACI,sBAAA;AjB8+CR;;AkBh/CA;EACI,aAAA;EACA,6BAAA;EACA,UAAA;EAEA,YAAA;EACA,qBAAA;AlBk/CJ;AkBh/CI;;EAEI,UAAA;EACA,uBAAA;AlBk/CR;;AmB1/CE;EACE,6DAAA;EACA,gCAAA;AnB6/CJ;AmB1/CI;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,mDAAA;AnB4/CN;AmB1/CM;EANF;IAOI,sBAAA;IACA,uBAAA;IACA,qBAAA;EnB6/CN;AACF;AmB1/CM;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AnB4/CR;AmB1/CQ;EACE,YAAA;AnB4/CV;AmBz/CQ;EACE,eAAA;AnB2/CV;AmBr/CE;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mDAAA;AnBu/CJ;AmBr/CI;EANF;IAOI,eAAA;IACA,4BAAA;EnBw/CJ;AACF;AmBt/CI;EACE,eAAA;AnBw/CN;AmBt/CM;EACE,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AnBw/CR;AmBr/CM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AnBu/CR;AmBr/CQ;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AnBu/CV;AmBr/CU;EACE,eAAA;EACA,WAAA;AnBu/CZ;AmBp/CU;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AnBs/CZ;AmBp/CY;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AnBs/Cd;AmBn/CY;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AnBq/Cd;AmBl/CY;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;AnBo/Cd;AmBl/Cc;EACE,cAAA;AnBo/ChB;AmBj/Cc;EACE,cAAA;AnBm/ChB;AmB3+CI;EACE,UAAA;EACA,YAAA;EACA,mBAAA;AnB6+CN;AmB5+CM;EAJF;IAKI,WAAA;IACA,WAAA;EnB++CN;AACF;AmB5+CI;EACE,eAAA;EACA,YAAA;AnB8+CN;AmB5+CM;EACE,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AnB8+CR;AmB3+CM;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,SAAA;EACA,yBAAA;AnB6+CR;AmB3+CQ;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;AnB6+CV;AmB3+CU;EACE,aAAA;EACA,8BAAA;AnB6+CZ;AmB3+CY;EACE,WAAA;EACA,eAAA;EACA,gBAAA;AnB6+Cd;AmB1+CY;EACE,eAAA;EACA,gBAAA;AnB4+Cd;AmBz+CY;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AnB2+Cd;AmBv+CU;EACE,WAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;AnBy+CZ;AmBp+CM;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AnBs+CR;AmBn+CQ;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AnBq+CV;AmBl+CQ;EACE,cAAA;EAEA,yBAAA;AnBm+CV;AmBh+CQ;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;AnBk+CV;AmB59CE;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;EACA,iBAAA;AnB89CJ;AmB59CI;EACE,+BAAA;AnB89CN;;AmBz9CA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;EACA,gCAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AnB49CF;;AoBltDA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;ApBqtDF;AoBltDE;EACE,iBAAA;EACA,oBAAA;ApBotDJ;AoBltDI;EACE,cAAA;EACA,yBAAA;EACA,UAAA;EACA,WAAA;ApBotDN;AoBjtDI;EACE,YAAA;ApBmtDN;AoBhtDI;EACE,gCAAA;ApBktDN;AoBhtDM;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,0BAAA;ApBktDR;AoB7sDE;EACE;IACE,aAAA;IACA,SAAA;IACA,eAAA;EpB+sDJ;AACF;AoB5sDE;EACE;IACE,cAAA;EpB8sDJ;EoB5sDE;IACE,cAAA;EpB8sDJ;EoBzsDE;IAEE,aAAA;IACA,mBAAA;EpB0sDJ;EoBxsDE;IACE,aAAA;IACA,eAAA;IACA,mBAAA;IACA,YAAA;IACA,gCAAA;EpB0sDJ;EoBvsDE;IACE,aAAA;IACA,sBAAA;IACA,SAAA;IACA,WAAA;EpBysDJ;AACF;AoBzsDM;EALF;IAMI,aAAA;EpB4sDN;AACF;AoB1uDE;EAgCE;IACE,eAAA;EpB6sDJ;AACF;;AoBxsDA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;ApB2sDF;AoBxsDE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ApB0sDJ;AoBxsDI;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;ApB0sDN;AoBtsDE;EACE,aAAA;EACA,6BAAA;EACA,sBAAA;EACA,SAAA;ApBwsDJ;AoBvsDI;EALF;IAMI,aAAA;EpB0sDJ;AACF;AoBzsDI;EARF;IASI,SAAA;IACA,mBAAA;IACA,aAAA;EpB4sDJ;AACF;AoB3sDI;EAbF;IAcI,SAAA;IACA,uBAAA;EpB8sDJ;AACF;AoB5sDI;EACE,WAAA;EACA,eAAA;EACA,gBAAA;ApB8sDN;AoB3sDI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;ApB6sDN;AoB3sDM;EACE,cAAA;EACA,eAAA;EACA,qBAAA;EACA,kCAAA;EACA,yBAAA;EACA,mBAAA;ApB6sDR;;AoBrsDE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;ApBwsDJ;AoBrsDE;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;ApBusDJ;AoBnsDE;EACE,cAAA;EACA,eAAA;ApBqsDJ;;AoBjsDA;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;ApBosDF;;AoBhsDE;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;ApBmsDJ;;AoB9rDE;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,6CAAA;ApBisDJ;AoB/rDI;EACE,yBAAA;ApBisDN;;AoB1rDA;EACE,kBAAA;ApB6rDF;AoB1rDE;EACE,gBAAA;ApB4rDJ;;AoBtrDE;EACE,eAAA;ApByrDJ;AoBxrDI;EAFF;IAGI,eAAA;EpB2rDJ;AACF;AoB1rDI;EALF;IAMI,eAAA;EpB6rDJ;AACF;;AoBzrDA;EACE;IACE,UAAA;EpB4rDF;EoB1rDA;IACE,cAAA;IACA,cAAA;EpB4rDF;AACF;AoBvrDA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,UAAA;ApByrDF;AoBxrDE;EALF;IAMI,UAAA;EpB2rDF;AACF;AoB1rDE;EARF;IASI,WAAA;EpB6rDF;AACF;AoB5rDE;EAXF;IAYI,mBAAA;IACA,uBAAA;IACA,UAAA;IACA,gBAAA;IACA,SAAA;EpB+rDF;AACF;AoB5rDE;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ApB8rDJ;AoB5rDI;EAPF;IAQI,eAAA;EpB+rDJ;AACF;AoB5rDE;EACE,cAAA;EACA,yBAAA;EACA,gBAAA;ApB8rDJ;AoB1rDE;EACE,mBAAA;EACA,WAAA;EACA,YAAA;ApB4rDJ;;AoBxrDA;EACE,aAAA;ApB2rDF;;AoBxrDA;EAEE;IACE,aAAA;EpB0rDF;EoBvrDA;IACE,cAAA;IACA,eAAA;IACA,cAAA;EpByrDF;EoBvrDA;IACE,gCAAA;IACA,oBAAA;EpByrDF;EoBvrDE;IACE,WAAA;IACA,eAAA;IACA,qBAAA;IACA,0BAAA;IACA,cAAA;EpByrDJ;EoBrrDE;IACE,aAAA;IACA,uBAAA;IACA,SAAA;EpBurDJ;AACF;AoBvrDM;EAJF;IAKI,sBAAA;IACA,mBAAA;EpB0rDN;AACF;AoBztDA;EAiCM;IACE,WAAA;IACA,eAAA;IACA,qBAAA;IACA,0BAAA;EpB2rDN;EoBvrDI;IACE,YAAA;EpByrDN;EoBvrDM;IACE,YAAA;IACA,aAAA;IACA,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EpByrDR;AACF;AoBzrDU;EATF;IAUI,WAAA;IACA,YAAA;IACA,aAAA;EpB4rDV;AACF;AoBrvDA;EA2DU;IACE,eAAA;IACA,iBAAA;EpB6rDV;EoBxrDM;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,cAAA;EpB0rDR;EoBvrDM;IACE,cAAA;IACA,eAAA;IACA,gBAAA;IACA,qBAAA;IACA,yBAAA;EpByrDR;EoBvrDQ;IACE,cAAA;IACA,qBAAA;IACA,kCAAA;IACA,yBAAA;IACA,kBAAA;EpByrDV;EoBnrDA;IACE,aAAA;IACA,SAAA;IACA,mBAAA;EpBqrDF;EoBnrDE;;;;IAIE,SAAA;IACA,aAAA;IACA,mBAAA;EpBqrDJ;EoBlrDE;IACE,aAAA;IACA,sBAAA;IACA,SAAA;EpBorDJ;AACF;AoBprDM;EAJF;IAKI,SAAA;EpBurDN;AACF;AoBtyDA;EAmHI;IACE,eAAA;IACA,gBAAA;IACA,qBAAA;IACA,yBAAA;EpBsrDJ;EoBlrDI;IACE,aAAA;IACA,kBAAA;IACA,mBAAA;IACA,eAAA;IACA,YAAA;EpBorDN;EoB/qDI;IACE,kBAAA;IACA,kBAAA;IACA,mBAAA;IACA,eAAA;IACA,YAAA;IACA,eAAA;EpBirDN;AACF;AoB3qDE;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ApB6qDJ;AoBzqDE;EACE,cAAA;EACA,eAAA;ApB2qDJ;;AoBvqDA;EACE;IACE,yBAAA;EpB0qDF;EoBxqDA;IACE,gBAAA;EpB0qDF;EoBvqDA;IACE,aAAA;EpByqDF;EoBtqDA;IACE,cAAA;IACA,gBAAA;IACA,MAAA;IACA,sBAAA;IACA,UAAA;EpBwqDF;EoBrqDA;IACE,aAAA;EpBuqDF;EoBpqDA;IACE,cAAA;IACA,WAAA;IACA,sBAAA;EpBsqDF;EoBnqDA;IACE,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,SAAA;IACA,gBAAA;IACA,aAAA;EpBqqDF;EoBlqDA;IACE,sBAAA;IACA,uBAAA;EpBoqDF;EoBlqDE;IACE,WAAA;IACA,eAAA;EpBoqDJ;EoBjqDE;IACE,eAAA;EpBmqDJ;EoB/pDA;IACE,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,eAAA;EpBiqDF;EoB/pDE;IACE,SAAA;EpBiqDJ;EoB9pDE;IACE,UAAA;EpBgqDJ;EoB7pDE;IACE,SAAA;EpB+pDJ;EoB3pDA;;;IAGE,eAAA;EpB6pDF;EoB1pDA;IACE,WAAA;IACA,uBAAA;EpB4pDF;AACF;AoBzpDA;EACE,yBAAA;ApB2pDF;AoBzpDE;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;ApB2pDJ;AoBzpDI;EACE,aAAA;EACA,eAAA;EACA,6BAAA;EACA,SAAA;ApB2pDN;AoB1pDM;EALF;IAMI,sBAAA;IACA,mBAAA;EpB6pDN;AACF;AoB3pDM;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,SAAA;ApB6pDR;AoB5pDQ;EANF;IAOI,WAAA;IACA,aAAA;EpB+pDR;AACF;AoB7pDQ;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;ApB+pDV;AoB7pDU;EACE,kCAAA;EACA,eAAA;EACA,sBAAA;ApB+pDZ;AoB5pDU;;EAEE,wBAAA;EACA,SAAA;ApB8pDZ;AoB3pDU;EACE,0BAAA,EAAA,YAAA;ApB6pDZ;AoB1pDU;EACE,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;ApB4pDZ;AoB1pDY;EACE,cAAA;EACA,kCAAA;EACA,eAAA;EACA,0BAAA;ApB4pDd;AoBxpDU;EACE,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,gCAAA;ApB0pDZ;AoBxpDY;EACE,cAAA;EACA,kCAAA;EACA,eAAA;EACA,0BAAA;ApB0pDd;;AoBjpDA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;ApBopDF;AoBlpDE;EACE,cAAA;EACA,eAAA;EACA,qBAAA;EACA,0BAAA;ApBopDJ;AoBjpDE;EACE,eAAA;ApBmpDJ;;AqBjyEA;EACE,yBAAA;EACA,eAAA;EACA,WAAA;ArBoyEF;AqBnyEE;EAJF;IAKI,eAAA;ErBsyEF;AACF;AqBpyEE;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;ArBsyEJ;AqBryEI;EARF;IASI,eAAA;IACA,SAAA;ErBwyEJ;AACF;AqBtyEI;EAbF;IAcI,uBAAA;ErByyEJ;AACF;AqBvyEI;EACE,gBAAA;ArByyEN;AqBvyEM;EACE,kBAAA;ArByyER;AqBvyEQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;ArByyEV;AqBvyEU;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;ArByyEZ;AqBxyEY;EALF;IAMI,QAAA;IACA,MAAA;IACA,WAAA;ErB2yEZ;AACF;AqBtyEM;EACE,cAAA;EACA,eAAA;EACA,iBAAA;ArBwyER;AqBpyEM;EACE,aAAA;EACA,SAAA;ArBsyER;AqB9xEM;EAHF;IAII,YAAA;ErBiyEN;AACF;AqB/xEM;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;ArBiyER;AqB/xEQ;EACE,WAAA;EACA,8BAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;ArBiyEV;AqB7xEM;EACE,mBAAA;EACA,eAAA;ArB+xER;AqB7xEQ;EACE,cAAA;EACA,eAAA;ArB+xEV;AqB1xEI;EACE,gBAAA;ArB4xEN;AqB1xEM;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;ArB4xER;AqB1xEQ;EACE,WAAA;EACA,8BAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;ArB4xEV;AqBxxEM;EACE,eAAA;EACA,iBAAA;EACA,cAAA;ArB0xER;AqBtxEM;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;ArBwxER;AqBtxEQ;EACE,WAAA;EACA,YAAA;EACA,oCAAA;EACA,+BAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;ArBwxEV;AqBtxEU;EAVF;IAWI,yBAAA;IACA,cAAA;ErByxEV;AACF;AqBpxEQ;EACE,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;ArBsxEV;;AsB16EE;EACE,WAAA;EACA,cAAA;EACA,sDAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;AtB66EJ;AsBz6EE;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;AtB26EJ;;AsBr6EA;EACE;IACE,WAAA;IACA,aAAA;EtBw6EF;EsBt6EE;IACE,WAAA;EtBw6EJ;EsBp6EQ;IACE,WAAA;IACA,aAAA;IACA,cAAA;EtBs6EV;EsBh6EU;IACE,WAAA;EtBk6EZ;EsB75EM;IACE,WAAA;EtB+5ER;EsB35EI;IACE,WAAA;EtB65EN;AACF;AuBx9EA;;EAEE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AvB09EF;AuBx9EE;EAVF;;IAWI,kBAAA;EvB49EF;AACF;AuB19EE;;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;AvB69EJ;AuB19EE;;EACE,aAAA;EACA,cAAA;EACA,sBAAA;AvB69EJ;AuB19EI;;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;AvB69EN;AuBz9EI;;EACE,iBAAA;AvB49EN;AuBz9EI;;EACE,UAAA;EACA,oBAAA;AvB49EN;AuBr9EM;;EACE,kBAAA;AvBw9ER;AuBt9EQ;;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;AvBy9EV;AuBp9EI;;EACE,aAAA;EACA,oBAAA;AvBu9EN;AuBr9EM;;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;AvBw9ER;AuBp9EI;;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;AvBu9EN;AuBr9EM;;EACE,yBAAA;AvBw9ER;AuBn9EE;;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AvBs9EJ;AuBn9EE;;EACE,iBAAA;AvBs9EJ;AuBl9EE;;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AvBq9EJ;AuBn9EI;;EACE,YAAA;EACA,WAAA;EACA,yBAAA;AvBs9EN;AuBn9EI;;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,eAAA;AvBs9EN;AuBl9EE;;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;AvBq9EJ;AuBn9EI;;EACE,eAAA;AvBs9EN;AuBh9EI;;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AvBm9EN;AuBj9EM;;EACE,+BAAA;EACA,eAAA;EACA,yBAAA;AvBo9ER;;AuB78EA;EACE;IACE,aAAA;EvBg9EF;EuB58EM;IACE,WAAA;EvB88ER;EuBx8EQ;IACE,WAAA;EvB08EV;EuBl8EM;IACE,WAAA;EvBo8ER;AACF;AwBtoFA;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AxBwoFF;AwBtoFE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AxBwoFJ;AwBtoFI;EACE,eAAA;AxBwoFN;AwBroFI;EACE,wDAAA;EACA,gBAAA;EACA,qBAAA;AxBuoFN;AwBnoFE;EACE,aAAA;EACA,sBAAA;EACA,cAAA;AxBqoFJ;AwBnoFI;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;AxBqoFN;AwBloFI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AxBooFN;AwBloFM;EACE,WAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AxBooFR;AwBjoFM;EACE,kBAAA;EACA,iBAAA;AxBmoFR;AwBhoFM;EACE,UAAA;AxBkoFR;AwB7nFI;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AxB+nFN;AwB7nFM;EACE,oCAAA;AxB+nFR;;AwBznFA;EACE;IACE,aAAA;ExB4nFF;EwB1nFE;IACE,cAAA;ExB4nFJ;EwB1nFI;IACE,WAAA;ExB4nFN;EwBznFI;IACE,WAAA;ExB2nFN;AACF;AwBtnFA;EACE,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AxBwnFF;AwBtnFE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AxBwnFJ;AwBtnFI;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AxBwnFN;AwBrnFI;EACE,eAAA;EACA,eAAA;AxBunFN;AwBnnFE;EACE,eAAA;EACA,gBAAA;AxBqnFJ;AwBlnFE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AxBonFJ;AwBnnFI;EALF;IAMI,eAAA;ExBsnFJ;AACF;AwBnnFE;EACE,yBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AxBqnFJ;AwBlnFE;EACE,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,gCAAA;AxBonFJ;AwBlnFI;EACE,yBAAA;EACA,cAAA;AxBonFN;;AyB1xFA;EACE,yCAAA;EACA,YAAA;AzB6xFF;AyB3xFE;EAJF;IAKI,UAAA;EzB8xFF;AACF;AyB1xFI;EADF;IAEI,QAAA;IACA,uBAAA;IACA,UAAA;EzB6xFJ;AACF;AyB3xFI;EACE,YAAA;AzB6xFN;AyB5xFM;EAFF;IAGI,WAAA;EzB+xFN;AACF;;A0BnzFA;EACE,aAAA;EACA,uBAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;A1BszFF;A0BrzFE;EAPF;IAQI,SAAA;IACA,eAAA;E1BwzFF;AACF;A0BtzFE;EACE,aAAA;EACA,6BAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;A1BwzFJ;A0BvzFI;EARF;IASI,eAAA;IACA,kBAAA;IACA,SAAA;E1B0zFJ;AACF;A0BxzFI;EACE,eAAA;EACA,mBAAA;A1B0zFN;A0BvzFI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;A1ByzFN;A0BvzFM;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;A1ByzFR;A0BxzFQ;EALF;IAMI,eAAA;E1B2zFR;AACF;A0BrzFE;EACE,WAAA;A1BuzFJ;A0BrzFI;EACE,eAAA;EACA,gBAAA;A1BuzFN;A0BpzFI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;A1BszFN;A0BnzFM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;A1BqzFR;A0BpzFQ;EAJF;IAKI,eAAA;IACA,SAAA;E1BuzFR;AACF;A0BrzFQ;EACE,aAAA;EACA,sBAAA;EACA,sDAAA;A1BuzFV;A0BtzFU;EAJF;IAKI,WAAA;E1ByzFV;AACF;A0BvzFU;EACE,WAAA;EACA,eAAA;A1ByzFZ;A0BxzFY;EAHF;IAII,eAAA;E1B2zFZ;AACF;A0BxzFU;EACE,YAAA;EACA,gCAAA;EACA,aAAA;EACA,0BAAA;A1B0zFZ;A0BtzFU;EACE,aAAA;EACA,YAAA;A1BwzFZ;A0BtzFY;EAJF;IAKI,aAAA;IACA,eAAA;E1ByzFZ;AACF;A0BtzFU;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,gCAAA;EACA,0BAAA;EACA,aAAA;A1BwzFZ;A0BpzFQ;EACE,sBAAA;A1BszFV;A0BjzFI;EACE,WAAA;EACA,aAAA;EACA,yBAAA;A1BmzFN;A0BlzFM;EAJF;IAKI,uBAAA;E1BqzFN;AACF;A0BnzFM;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;A1BqzFR;;A2Bl8FA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;A3Bq8FF;A2Bn8FE;EACE,yDAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;A3Bq8FJ;A2Bl8FE;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;A3Bo8FJ;;A4B59FA;EACE,WAAA;A5B+9FF;;A6Bh+FA;EACE,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EAGA,SAAA;EACA,aAAA;EACA,WAAA;A7Bi+FF;;A6B99FA;EACE,YAAA;A7Bi+FF;;A6Bz9FA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;A7B49FF;A6B39FE;EALF;IAMI,uBAAA;E7B89FF;AACF;A6B59FE;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;A7B89FJ;A6B79FI;EANF;IAOI,WAAA;IACA,YAAA;E7Bg+FJ;AACF;A6B99FI;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;A7Bg+FN;A6B/9FM;EALF;IAMI,WAAA;E7Bk+FN;AACF;A6B/9FI;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;A7Bi+FN;;A6B59FA;EACE,eAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;A7B+9FF;A6B99FE;EANF;IAOI,eAAA;IACA,WAAA;E7Bi+FF;AACF;A6B/9FE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;A7Bi+FJ;A6B19FE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;A7B49FJ;A6B19FI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;A7B49FN;A6Bz9FI;EACE,aAAA;A7B29FN;;A6Bt9FA;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,sBAAA;A7By9FF;A6Bv9FE;EACE,aAAA;EACA,eAAA;EACA,SAAA;A7By9FJ;A6Bv9FI;EACE,kBAAA;A7By9FN;A6Bt9FM;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;A7Bw9FR;A6Br9FM;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;A7Bu9FR;;A8B/lGA;EAEE,mBAAA;EAEA,kBAAA;EACA,eAAA;EAEA,kCAAA;A9B+lGF;A8B7lGE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gCAAA;A9B+lGJ;A8B7lGI;EACE,YAAA;A9B+lGN;A8B3lGI;EACE,WAAA;EACA,cAAA;EACA,gBAAA;EACA,+B5BzBO;E4B0BP,eAAA;EACA,oBAAA;A9B6lGN;A8BvlGE;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,SAAA;EACA,gCAAA;A9BylGJ;A8BvlGI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EAGA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;A9BulGN;A8BrlGM;EACE,mBAAA;EACA,mBAAA;EACA,WAAA;A9BulGR;A8BplGM;EACE,eAAA;A9BslGR;A8B/kGI;EACE,mBAAA;EACA,mBAAA;EACA,WAAA;A9BilGN;;A8B1kGA;EAEE,YAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;A9B4kGF;A8B1kGE;EACE,0CAAA;A9B4kGJ;A8BzkGE;EACE,eAAA;A9B2kGJ;;A8BvkGA;EACE,YAAA;EACA,gCAAA;A9B0kGF;A8BxkGE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;A9B0kGJ;A8BxkGI;EACE,WAAA;EACA,eAAA;A9B0kGN;;A8BnkGA;EACE,YAAA;EACA,gCAAA;A9BskGF;A8BpkGE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;A9BskGJ;A8BpkGI;EACE,WAAA;EACA,eAAA;EACA,kBAAA;A9BskGN;A8BjkGE;EACE,gCAAA;A9BmkGJ;A8BjkGI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;A9BmkGN;;A+BrtGA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;A/BwtGJ","sourcesContent":[".main_icons {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 25px;\n\n  .main_buying,\n  .buying_icon,\n  .favorites {\n    position: relative;\n  }\n\n  .main_user {\n    cursor: pointer;\n  }\n\n  .buying_count,\n  .favorite_count {\n    font-size: 16px;\n    color: #fff;\n    position: absolute;\n    bottom: 14px;\n    left: 15px;\n    z-index: 1;\n    border-radius: 50%;\n    width: 20px;\n    height: 20px;\n    background-color: #000000;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}","@import \"burgerMenu\";\n@import \"variables\";\n@import 'mainIcons';\n@import 'header';\n@import 'slider';\n@import \"categories\";\n@import 'contact';\n@import \"about\";\n@import 'products';\n@import 'productItem';\n@import \"navigateSection\";\n@import \"~slick-carousel/slick/slick.css\";\n@import \"~slick-carousel/slick/slick-theme.css\";\n@import 'whoWeAre';\n@import 'discount';\n@import 'ourProducts';\n@import \"specialOrder\";\n@import \"ourPartners\";\n@import \"ourClientOpinion\";\n@import \"slidePrevBtn\";\n@import \"slideNextBtn\";\n@import \"categoriesItem\";\n@import \"payment\";\n@import 'cart';\n@import 'footer';\n@import 'signUp';\n@import 'signIn';\n@import 'resetPass';\n@import 'authModal';\n@import 'contactUs';\n@import \"notFound\";\n@import \"../adminStyles/user/users\";\n@import '../adminStyles/slides/slides';\n@import '../adminStyles/adminNavigation';\n@import '../adminStyles/adminDashboard';\n\n\n","* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: $robotoFont;\n  font-size: 14px;\n\n}\n\nhtml {\n  height: 100%;\n}\n\n\nheader {\n  height: 155px;\n  padding: 18px 40px 18px 0;\n  background-color: #fff;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #C0C0C0;\n\n  .logo_Items {\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    text-transform: uppercase;\n    line-height: 24px;\n    font-size: 18px;\n    letter-spacing: 0.54px;\n    color: #070707;\n    cursor: pointer;\n\n    .logo_text {\n      font-size: 24px;\n      line-height: 28px;\n      font-weight: 300;\n\n      @media(max-width: 600px) {\n        display: none;\n      }\n    }\n\n    .logo {\n      width: 161px;\n      max-width: 100%;\n    }\n  }\n\n  .header_menu {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: space-between;\n    height: 90px;\n    @media (max-width: 769px) {\n      justify-content: space-around;\n    }\n\n    .header_languages {\n      button {\n        font-size: 14px;\n        font-weight: 700;\n        padding: 0 clamp(0.3125rem, 0.2232rem + 0.4464vw, 0.625rem);\n        text-decoration: none;\n        text-transform: uppercase;\n        cursor: pointer;\n        color: #868181;\n        border-color: transparent;\n        background-color: transparent;\n\n        &:nth-child(2) {\n          border-right: 3px solid #B0D404;\n          border-left: 3px solid #B0D404;\n        }\n      }\n\n      .selected {\n        color: #000;\n      }\n    }\n\n    .main_menu {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      gap: clamp(3.125rem, -8.1646rem + 18.0995vw, 8.125rem);\n      font-weight: 700;\n\n      @media (max-width: 998px) {\n        gap: 30px;\n      }\n    }\n\n    main {\n      display: flex;\n      gap: 30px;\n      @media (max-width: 998px) {\n        display: none;\n      }\n\n      a {\n        color: #555;\n        transition: all .3s ease-in-out;\n        position: relative;\n        text-transform: capitalize;\n        font-size: 16px;\n        letter-spacing: 1px;\n\n        &.link {\n          color: #555;\n        }\n\n        &.active {\n          color: #F56E91;\n        }\n\n        &.hover {\n          color: #F56E91;\n        }\n\n      }\n\n\n    }\n\n    .web_main {\n      display: none;\n      position: absolute;\n      right: 0;\n      top: 0;\n      height: 100vh;\n      width: 100vw;\n      background-color: rgb(0 0 0 / 85%);\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      gap: 50px;\n      transition: all .2s ease-in-out;\n      z-index: 10;\n\n      @media (max-width: 998px) {\n        display: flex;\n      }\n\n      a {\n        padding: 10px 0;\n        font-size: clamp(1.875rem, 1.2833rem + 2.9586vw, 3.125rem);\n        font-weight: 700;\n        color: #555;\n        transition: all .2s ease-in-out;\n        @media (max-width: 769px) {\n          padding: 0;\n        }\n\n        &.link {\n          color: #fff;\n        }\n\n        &.active {\n          color: #F56E91;\n        }\n\n        &.hover {\n          color: #F56E91;\n        }\n      }\n    }\n  }\n\n}\n\n\n//burger style\n.burger_menu {\n  z-index: 11;\n  display: none;\n  @media (max-width: 998px) {\n    display: block;\n  }\n\n  .checkboxtoggler {\n    width: 40px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    cursor: pointer;\n\n    .line-1 {\n      background: #000;\n      height: 0.3em;\n      border-radius: 10em;\n      transition-duration: 500ms;\n      caret-color: transparent;\n\n    }\n\n    .line-2 {\n      background: #000;\n      height: 0.3em;\n      border-radius: 10em;\n      transition-duration: 500ms;\n      caret-color: transparent;\n    }\n\n    .line-3 {\n      background: #000;\n      height: 0.3em;\n      border-radius: 10em;\n      transition-duration: 500ms;\n      caret-color: transparent;\n    }\n  }\n\n  #toggleChecker {\n    height: 3em;\n    width: 100%;\n    display: none;\n  }\n\n  #toggleChecker:checked + #togglerLable .checkboxtoggler .line-1 {\n    -webkit-transform: rotate(45deg) translateY(0.7em) translateX(0.7em);\n    -ms-transform: rotate(45deg) translateY(0.7em) translateX(0.7em);\n    transform: rotate(45deg) translateY(0.7em) translateX(0.7em);\n    background-color: #F56E91;\n  }\n\n  #toggleChecker:checked + #togglerLable .checkboxtoggler .line-2 {\n    -webkit-transform: rotate(-45deg) translateY(0em) translateX(0.1em);\n    -ms-transform: rotate(-45deg) translateY(0em) translateX(0.1em);\n    transform: rotate(-45deg) translateY(0em) translateX(0.1em);\n    background-color: #F56E91;\n\n  }\n\n  #toggleChecker:checked + #togglerLable .checkboxtoggler .line-3 {\n    transform: scaleX(0);\n    transform-origin: left;\n    background-color: #F56E91;\n\n  }\n}\n","$robotoFont: Roboto, sans-serif;\n$fontweight: 400;\n$fontsize: 14px;\n\n",".slider {\n\n  ul.slick-dots {\n    bottom: 30px !important;\n  }\n\n  .slide-bg {\n\n    .slick-slider,\n    .slick-list {\n      overflow: hidden;\n      width: 100%;\n    }\n\n\n    .img-block {\n      width: 100%;\n      position: relative;\n      display: flex;\n      align-items: center;\n      @media (max-width: 600px) {\n        width: 100%;\n      }\n\n      img {\n        max-width: 100%;\n        width: 100vw;\n        height: calc(100vh - 155px);\n        object-fit: cover;\n\n        @media (max-width: 600px) {\n          height: 400px;\n        }\n      }\n\n      .slider-text-block {\n        width: 100%;\n        position: absolute;\n        display: flex;\n        flex-direction: column;\n        gap: clamp(1.25rem, 1.1542rem + 2.1898vw, 3.125rem);\n\n        .slider-title {\n          font-family: $robotoFont;\n          color: #000;\n          font-size: clamp(2.25rem, 1.6429rem + 3.0357vw, 4.375rem);\n          font-weight: 300;\n          text-transform: uppercase;\n          padding-left: 10%;\n        }\n\n\n        .slider-text {\n          border-left: 9px solid #F56E91;\n          height: 80px;\n          padding-left: 24px;\n          display: flex;\n\n          align-items: center;\n          margin-left: 10%;\n          @media (max-width: 600px) {\n            height: 100%;\n          }\n\n          .slider-description {\n            color: #0B1203;\n            font-family: $robotoFont;\n            font-size: clamp(1.25rem, 0.8929rem + 1.7857vw, 2.5rem);\n            font-weight: 500;\n            //line-height: 39px;\n            text-transform: uppercase;\n          }\n        }\n\n        .deliver {\n          width: clamp(17.5rem, 9.8749rem + 38.1257vw, 44.188rem);\n          height: clamp(3.125rem, 2.6964rem + 2.1429vw, 4.625rem);\n          background: #B0D404;\n          display: flex;\n          align-items: center;\n          justify-content: end;\n          padding: 10px 25px 10px 0;\n          gap: 30px;\n          @media (max-width: 600px) {\n            width: 100%;\n          }\n\n\n          .delivery-title {\n            color: #FFF;\n            font-family: $robotoFont;\n            font-size: clamp(1.0625rem, 0.8304rem + 1.1607vw, 1.875rem);\n            display: flex;\n            flex-direction: column;\n            text-transform: uppercase;\n\n            span {\n              display: block;\n              color: #FFF;\n              font-size: clamp(1rem, 0.8929rem + 0.5357vw, 1.375rem);\n              font-weight: 300;\n            }\n          }\n        }\n      }\n    }\n  }\n}",".categories {\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 50px 10px;\n\n  .categories-img-block {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 30px;\n    @media (max-width: 700px) {\n      flex-direction: column;\n    }\n\n    .categories-img {\n      max-width: 100%;\n      width: 400px;\n      height: clamp(12.5rem, 5.8036rem + 17.8571vw, 21.875rem);\n      object-fit: cover;\n      @media (max-width: 700px) {\n        //height: 100%;\n        //object-fit: cover;\n      }\n\n    }\n\n    .our-products-text {\n      font-size: clamp(1.125rem, 0.3661rem + 2.0238vw, 2.1875rem);\n      @media (max-width: 700px) {\n        font-size: clamp(1.5625rem, 2.5018rem + -0.0047vw, 2.5rem);\n      }\n\n      svg {\n        width: clamp(1.125rem, 0.3661rem + 2.0238vw, 2.1875rem);\n      }\n    }\n  }\n}",".section_padding {\n  padding: 35px 0;\n  @media (max-width: 600px) {\n    padding: 0 0 35px 0;\n  }\n\n  .contact_info {\n    display: flex;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n    gap: 70px;\n    margin-top: 90px;\n    padding: 0 160px;\n    @media (max-width: 1320px) {\n      gap: 30px;\n    }\n    @media (max-width: 1201px) {\n      max-width: 1440px;\n      margin: 0 auto;\n      padding: 50px;\n    }\n    @media (max-width: 728px) {\n      padding: 15px;\n    }\n\n    .contact_title {\n      width: calc(50% - 70px);\n      display: flex;\n      flex-direction: column;\n      gap: 50px;\n\n      @media (max-width: 1201px) {\n        width: 100%;\n        flex-direction: row;\n        align-items: center;\n      }\n      @media (max-width: 600px) {\n        flex-direction: column;\n      }\n\n      .contact_list {\n        max-width: 560px;\n        border: 1px solid #E5E5E5;\n        position: relative;\n        padding: 40px 50px;\n        border-left: 8px solid #B0D404;\n        @media (max-width: 600px) {\n          padding: 20px;\n        }\n\n        .contact_address {\n          display: flex;\n          flex-direction: column;\n          justify-content: space-between;\n          gap: 10px;\n\n          h4 {\n            color: #000;\n            font-size: 16px;\n            font-weight: 700;\n            line-height: 24px;\n            letter-spacing: 0.48px;\n            text-transform: uppercase;\n          }\n\n          p {\n            color: #A3A3A3;\n            font-family: 'Inter', sans-serif;\n            font-size: 17px;\n            font-weight: 500;\n            line-height: 27px;\n          }\n\n          a {\n            color: #F56E91;\n            font-family: 'Inter', sans-serif;\n            font-size: 16px;\n            font-weight: 700;\n            line-height: 34px;\n            cursor: pointer;\n          }\n        }\n\n\n        h3 {\n          font-size: 16px;\n          font-weight: 700;\n          line-height: 24px;\n          letter-spacing: 0.48px;\n\n        }\n\n        .contact_open {\n          color: #B0D404;\n        }\n\n        .contact_closed {\n          color: #F56E91;\n        }\n\n      }\n\n      .contact_text {\n        color: #000;\n        font-family: 'Inter', sans-serif;\n        font-size: 16px;\n        line-height: 26px;\n      }\n    }\n  }\n\n  .contact_map {\n    width: calc(50% - 70px);\n    z-index: 5;\n\n    @media (max-width: 1200px) {\n      width: 100%;\n    }\n\n\n    .leaflet-popup.leaflet-zoom-animated {\n      @media(max-width: 650px) {\n        opacity: 0 !important;\n      }\n    }\n\n    .leaflet-popup-content {\n      width: 400px !important;\n    }\n\n\n    .map_info {\n      display: flex;\n      justify-content: space-between;\n      gap: 20px;\n      align-items: center;\n\n      .map_img {\n        max-width: 100%;\n        width: 142px;\n      }\n\n      .map_text {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        flex-direction: column;\n\n        h5 {\n          color: #000;\n          font-size: 15px;\n          font-weight: 700;\n          line-height: 24px;\n          letter-spacing: 0.48px;\n          text-transform: uppercase;\n        }\n\n        p {\n          color: #AAA;\n          font-family: 'Inter', sans-serif;\n          font-size: 14px;\n          font-weight: 500;\n          line-height: 27px;\n          margin: 5px 0;\n        }\n\n        span {\n          color: #AAA;\n          font-family: 'Inter', sans-serif;\n          font-size: 16px;\n          font-weight: 700;\n          line-height: 34px;\n        }\n      }\n\n    }\n  }\n}\n",".about_text {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  max-width: 1000px;\n  margin: 5% auto;\n  padding: 0 30px;\n\n\n  p {\n    font-size: 16px;\n    line-height: 34px;\n    text-align: justify;\n    text-align: justify;\n  }\n}",".products {\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 0 15px;\n\n\n  .product_filer {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    align-items: center;\n    padding: 40px 0;\n    gap: 40px;\n\n    @media (max-width: 735px) {\n      justify-content: center;\n    }\n\n\n    .product_name {\n      overflow-x: auto;\n      scrollbar-width: none;\n\n      //.slick-slider {\n      //  width: 680px;\n      //\n      //  .slick-track {\n      //    display: flex;\n      //    gap: 20px;\n      //    justify-content: flex-start;\n      //  }\n      //}\n\n      ul {\n        display: flex;\n        gap: clamp(0.625rem, 0.4464rem + 0.8929vw, 1.25rem);\n        list-style: none;\n\n        li {\n          cursor: pointer;\n          font-weight: 700;\n          text-transform: uppercase;\n\n          &.active {\n            color: #F56E91;\n          }\n        }\n      }\n    }\n\n    .product_search {\n      position: relative;\n\n      input {\n        position: relative;\n        border-radius: 8px;\n        border: 1px solid #D6D6D6;\n        height: 50px;\n        width: clamp(17.5rem, 17.1429rem + 1.7857vw, 18.75rem);\n        padding: 0 16px;\n        outline: none;\n        font-size: 16px;\n      }\n\n      .glass_icon {\n        position: absolute;\n        right: 15px;\n        top: 50%;\n        transform: translateY(-50%);\n        background-color: transparent;\n        border: none;\n        cursor: pointer;\n      }\n    }\n  }\n\n\n}\n\n.data_img {\n  max-width: 100%;\n  width: 100%;\n  height: 244px;\n  object-fit: cover;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.products_data {\n  display: flex;\n  justify-content: center;\n  align-content: stretch;\n  align-items: stretch;\n  gap: 36px;\n  flex-wrap: wrap;\n  min-height: 500px;\n\n  @media (max-width: 450px) {\n    min-height: 100%;\n  }\n}\n\n.data-frame {\n  border-radius: 20px;\n  border: 1px solid #B7B5B5;\n  background: #FFF;\n  padding: 24px;\n  //height: 100%;\n  height: 460px;\n  width: 300px;\n  justify-content: space-between;\n  display: flex;\n  flex-direction: column;\n\n  .cart-frame {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    //height: calc(100% - 140px);\n    margin-top: 30px;\n    gap: 16px;\n  }\n\n  .slick-dots {\n    bottom: -20px;\n  }\n\n\n  .data_title {\n    font-size: 20px;\n    font-weight: 700;\n    text-align: center;\n  }\n\n  .data_price {\n    display: flex;\n    justify-content: center;\n    gap: 16px;\n    align-items: center;\n\n    .data_discount {\n      color: #ABABAB;\n      font-size: 16px;\n      font-weight: 500;\n      line-height: normal;\n      text-decoration: line-through;\n    }\n\n    .data_count {\n      color: #F56E91;\n      font-size: 18px;\n      font-weight: 800;\n      line-height: normal;\n    }\n  }\n}\n\n.data_buttons {\n  display: flex;\n  justify-content: space-evenly;\n  gap: 16px;\n  align-items: center;\n}\n\n.data_add-button {\n  border-radius: 8px;\n  background: #B0D404;\n  width: 100%;\n  padding: 10px 0;\n  color: #fff;\n  border: 1px solid transparent;\n  font-size: 20px;\n  font-weight: 700;\n  cursor: pointer;\n  //transition: all ease-in-out .3s;\n  //\n  //&:hover {\n  //  background-color: #fff;\n  //  color: #B0D404;\n  //  border-color: #B0D404;\n  //}\n}\n\n.data_added-button {\n  background: #fff;\n  color: #B0D404;\n  border: 1px solid #B0D404;\n  border-radius: 8px;\n  width: 100%;\n  padding: 10px;\n  font-size: 20px;\n  font-weight: 700;\n  cursor: pointer;\n\n}\n\n\n.data_remove-button {\n  border-radius: 8px;\n  background: #df2656;\n  width: 100%;\n  padding: 10px 0;\n  color: #fff;\n  border: none;\n  font-size: 22px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.data_heartIcon {\n  padding: 7px 15px;\n  border-radius: 8px;\n  background: #F2F0F0;\n  cursor: pointer;\n\n\n}\n\n\n.pagination {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 50px;\n\n  .MuiPagination-ul {\n    button {\n      border: none;\n      color: #aaa;\n      font-size: 20px;\n      font-weight: 700;\n      width: 45px;\n      height: 45px;\n\n      svg {\n        font-size: 30px;\n      }\n    }\n\n    .Mui-selected {\n      border-radius: 8px;\n      background: #F56E91;\n      border: none;\n      color: #fff;\n    }\n  }\n}\n\n\n.favorites_title {\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 50px 0;\n}\n\n.empty-favorites {\n  position: relative;\n\n  .empty-favorites_inner {\n    position: absolute;\n    left: 50%;\n    right: 50%;\n    width: 100%;\n    transform: translate(-50%, -50%);\n    top: 50%;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    justify-content: center;\n    align-items: center;\n    z-index: 2;\n    text-align: center;\n    padding: 0 15px;\n\n    h3 {\n      color: #000;\n      font-family: 'Inter', sans-serif;\n      font-size: clamp(1rem, 0.6429rem + 1.7857vw, 2.25rem);\n    }\n\n    p {\n      color: #4F4F4F;\n      font-family: Inter, sans-serif;\n      font-size: clamp(0.75rem, 0.6429rem + 0.5357vw, 1.125rem);\n    }\n  }\n}",".single-page {\n  display: flex;\n  justify-content: center;\n  gap: 60px;\n  padding: clamp(0.9375rem, -1.1546rem + 10.4603vw, 4.0625rem) 15px;\n  max-width: 1440px;\n  margin: 0 auto;\n  @media (max-width: 798px) {\n    flex-direction: column;\n  }\n\n\n  .single-page_slider {\n    display: flex;\n    flex-direction: row-reverse;\n    align-items: center;\n    gap: 15px;\n    height: 530px;\n    @media (max-width: 1100px) {\n      flex-direction: column;\n      height: 100%;\n    }\n\n\n    .slider_image {\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n      align-items: center;\n      max-width: 100%;\n      width: clamp(23.125rem, 1.6556rem + 43.0464vw, 31.25rem);\n      @media (max-width: 798px) {\n        width: 100%;\n      }\n\n      .single_slide-title {\n        max-width: 100%;\n        height: 545px;\n        border-radius: 16px;\n        padding: 35px;\n        background-color: #F8F8F8;\n        @media (max-width: 798px) {\n          height: clamp(24.375rem, 17.262rem + 35.5649vw, 35rem);\n          padding: clamp(0.9375rem, 0.1007rem + 4.1841vw, 2.1875rem);\n        }\n\n        .single_slide-img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n          border-radius: 16px;\n        }\n      }\n\n      .slick-slider.slick-initialized {\n        width: clamp(23.125rem, 1.6556rem + 43.0464vw, 31.25rem);\n        max-width: 100%;\n        @media (max-width: 798px) {\n          width: 100%;\n        }\n\n      }\n    }\n  }\n}\n\n.single-page_title {\n  max-width: 400px;\n  display: flex;\n  flex-direction: column;\n  gap: clamp(1.25rem, 0.7143rem + 2.6786vw, 3.125rem);\n  @media (max-width: 798px) {\n    margin: 0 auto;\n    text-align: center;\n  }\n\n  .sigle-page_items-count {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .single-page_text,\n  .single-page_price {\n    display: flex;\n    flex-direction: column;\n    gap: clamp(0.9375rem, 1.1467rem + -1.046vw, 0.625rem);\n  }\n\n  .btn-group {\n    display: flex;\n    align-items: center;\n  }\n\n  .single-page_text {\n    h3 {\n      color: #000;\n      font-family: 'Inter', sans-serif;\n      font-size: 30px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      text-transform: capitalize;\n      @media (max-width: 768px) {\n        font-size: clamp(1.25rem, 0.8316rem + 2.0921vw, 1.875rem);\n      }\n    }\n\n    p {\n      color: #828282;\n      font-size: 16px;\n      line-height: 25px;\n      text-transform: capitalize;\n      text-align: justify;\n    }\n  }\n\n  .single-page_count {\n    display: flex;\n    gap: 20px;\n    @media (max-width: 798px) {\n      justify-content: center;\n    }\n\n    span {\n      font-size: 20px;\n      letter-spacing: 1.25px;\n      text-transform: uppercase;\n    }\n\n    .page_discount {\n      color: #939393;\n      text-decoration-line: line-through;\n    }\n\n    .page_count {\n      color: #F56E91;\n      font-weight: 700;\n    }\n  }\n}\n\n.small_slider {\n  //width: 120spx;\n  position: relative;\n  @media (max-width: 1100px) {\n    display: block;\n    width: 400px;\n  }\n  @media (max-width: 798px) {\n    display: block;\n    width: 400px;\n  }\n  @media (max-width: 470px) {\n    display: block;\n    width: 250px;\n  }\n\n  @media (max-width: 400px) {\n    display: none;\n  }\n\n  .slick-slider.slick-initialized {\n    //width: 200px;\n    margin-right: 50px;\n    @media (max-width: 1100px) {\n      margin-right: 0;\n    }\n    @media (max-width: 798px) {\n      width: 100%;\n    }\n\n    .slick-slide {\n      //margin: 10px 0;\n\n    }\n\n    .slick-list {\n      //height: 470px !important;\n    }\n\n    .slick-track {\n      //display: flex;\n      //flex-direction: column;\n      height: 100% !important;\n      width: 120px;\n    }\n\n    .slick-disabled {\n      background-color: red !important;\n    }\n\n    .arrowNext,\n    .arrowPrev {\n      background-color: #F8F8F8;\n      width: 36px;\n      height: 34px;\n      cursor: pointer;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      border-radius: 8px;\n      position: absolute;\n      border: none;\n    }\n\n\n    .arrowNext {\n      top: -40px;\n      left: 50%;\n      right: 50%;\n      transform: translate(-50%, -50%);\n      @media (max-width: 1100px) {\n        top: 50%;\n        left: calc(100% + 15px);\n        transform: translate(-50%, -50%) rotate(90deg);\n      }\n      @media (max-width: 798px) {\n        top: 50%;\n        left: calc(100% + 15px);\n        transform: translate(-50%, -50%) rotate(90deg);\n      }\n\n    }\n\n\n    .arrowPrev {\n      top: calc(100% + 34px);\n      left: 50%;\n      right: 50%;\n      transform: translate(-50%, -50%);\n      @media (max-width: 1100px) {\n        left: -25px;\n        transform: translate(-50%, -50%) rotate(90deg);\n        top: 50%;\n      }\n      @media (max-width: 798px) {\n        left: -25px;\n        transform: translate(-50%, -50%) rotate(90deg);\n        top: 50%;\n      }\n\n    }\n  }\n\n  .slider_image-item {\n    background-color: #F8F8F8;\n    padding: 20px 18px;\n    width: 120px !important;\n    height: 135px;\n    border-radius: 16px;\n\n    img {\n      max-width: 100%;\n      width: 100%;\n      height: 100%;\n      cursor: pointer;\n      object-fit: cover;\n    }\n\n  }\n}",".navigation {\n  display: flex;\n  gap: 10px;\n  padding-left: clamp(0.9375rem, 0.0446rem + 4.4643vw, 4.0625rem);\n  flex-wrap: wrap;\n  @media (max-width: 600px) {\n    display: none;\n  }\n\n\n  a, span {\n    color: #958D8D;\n    font-size: 15px;\n    font-weight: 400;\n  }\n\n  .navigate_link-color {\n    color: #F56E91;\n    font-family: 'Inter', sans-serif;\n    font-size: 15px;\n    font-weight: 700;\n  }\n}\n\n.navigation_title {\n  color: #000;\n  font-family: 'Inter', sans-serif;\n  font-size: clamp(1.25rem, 1.0714rem + 0.8929vw, 1.875rem);\n  font-weight: 400;\n  padding: 25px 0 25px clamp(0.9375rem, 0.0446rem + 4.4643vw, 4.0625rem);\n  border-bottom: 2px solid #CFCFCF;\n}\n\n.navigation_frame {\n  max-width: 100%;\n  height: 150px;\n  position: relative;\n  @media (max-width: 850px) {\n    height: 100px;\n  }\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    position: relative;\n\n    &::before {\n      content: '';\n      width: 100%;\n      height: auto;\n      position: absolute;\n      left: 0;\n      top: 0;\n      background-color: red;\n    }\n  }\n\n  span {\n    width: 100%;\n    height: 100%;\n    background: rgba(245, 110, 145, .8);\n    display: block;\n    position: absolute;\n    top: 0;\n  }\n\n  .layer_title {\n    color: #fff;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 24px;\n    letter-spacing: 0.72px;\n    text-transform: uppercase;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    position: absolute;\n    @media (max-width: 850px) {\n      font-size: 18px;\n    }\n  }\n}",".who-we-are-body {\n\n  position: relative;\n\n  .style-svg {\n    position: absolute;\n    z-index: 1;\n    transform: translate(-50%, -50%);\n    width: 100%;\n    height: 100%;\n    inset: 50% 50% 0 50%;\n\n    svg {\n      width: 100%;\n      padding: 0 20px;\n    }\n  }\n\n  .who-we-are-info-block {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: clamp(1.875rem, -9.7917rem + 20.7407vw, 8.875rem);\n    flex-wrap: wrap;\n    padding-top: clamp(1.5rem, 0.8571rem + 3.2143vw, 3.75rem);\n    padding-bottom: clamp(2.5rem, 1.4286rem + 5.3571vw, 6.25rem);\n    position: relative;\n\n    .who-we-are-img-block {\n      padding: 20px;\n      position: relative;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      @media (max-width: 530px) {\n        width: 80%\n      }\n\n      &::after {\n        border-top: 10px solid #F56E91;\n        border-right: 10px solid #F56E91;\n        position: absolute;\n        content: \"\";\n        width: 100px;\n        height: 100px;\n        top: 0;\n        right: 0;\n      }\n\n      &:before {\n        content: \"\";\n        width: 111px;\n        height: 113px;\n        background-color: #EDEDED;\n        z-index: 1;\n        position: absolute;\n        bottom: -20px;\n        left: -20px;\n      }\n\n      img {\n        max-width: 100%;\n        height: 95%;\n        z-index: 5;\n        @media (max-width: 530px) {\n          max-width: 100%;\n        }\n      }\n    }\n\n    .who-we-are-text-block {\n      width: clamp(18.75rem, 16.6071rem + 10.7143vw, 26.25rem);\n      padding: 0 20px;\n      z-index: 1;\n      @media (max-width: 884px) {\n        width: 80%;\n      }\n      @media (max-width: 600px) {\n        width: 100%;\n      }\n\n      .who-we-are-text-info {\n        .who-we-are-title {\n          color: #4D4D4D;\n          font-family: \"Inter\", sans-serif;\n          font-size: clamp(2rem, 1.8571rem + 0.7143vw, 2.5rem);\n          font-weight: 500;\n          margin-bottom: 30px;\n        }\n\n        .who-we-are-text {\n          color: #6F6F6F;\n          font-family: \"Inter\", sans-serif;\n          font-size: clamp(1rem, 0.9643rem + 0.1786vw, 1.125rem);\n          font-weight: 500;\n          line-height: 30px;\n          text-align: justify;\n        }\n\n        .who-we-are-description {\n          min-height: 115px;\n          border-left: 9px solid #B0D404;\n          padding-left: 20px;\n          margin: 28px 0 0 15px;\n          color: #6F6F6F;\n          font-family: 'Inter', sans-serif;\n          font-size: clamp(0.7rem, 0.9643rem + 0.1786vw, 1.125rem);\n          font-weight: 500;\n          line-height: 30px;\n          text-align: justify;\n          @media (max-width: 600px) {\n            margin-left: 0;\n          }\n        }\n      }\n    }\n  }\n}",".discount-bg {\n  position: relative;\n\n  .discountBg {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    @media (max-width: 600px) {\n      height: 160px;\n    }\n\n  }\n\n  .discount-block {\n    position: absolute;\n    top: 0;\n    padding-left: 120px;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    @media (max-width: 800px) {\n      padding-left: 60px;\n    }\n\n    .discount-title {\n      color: #F56E91;\n      font-family: $robotoFont;\n      font-size: clamp(2.25rem, 1.8214rem + 2.1429vw, 3.75rem);\n      font-weight: 900;\n    }\n\n    .discount-description {\n      color: rgba(71, 28, 28, 0.9);\n      font-family: $robotoFont;\n      font-size: clamp(1rem, 0.5714rem + 2.1429vw, 2.5rem);\n      font-weight: 300;\n    }\n\n  }\n\n}",".our-products-block {\n  padding: 50px 0;\n\n\n  .header-text {\n    //max-width: 100%;\n    //width: 600px;\n  }\n}\n\n.our-products-title {\n  display: flex;\n  //flex-wrap: wrap;\n  gap: 30px;\n  //margin-bottom: 30px;\n  @media (max-width: 600px) {\n    //flex-wrap: nowrap;\n    flex-direction: column;\n    margin-bottom: 0;\n    padding: 0 30px;\n  }\n\n\n  .our-products-img-item {\n    //max-height: 762px;\n    //max-width: 712px;\n    flex: 1 1 45%;\n\n    .our-products-img {\n      height: 100%;\n      width: 100%;\n      object-fit: cover;\n      @media(max-width: 600px) {\n        height: 300px;\n        max-width: 100%;\n      }\n\n    }\n  }\n}\n\n.our-products-img-item {\n  position: relative;\n  cursor: pointer;\n  transition: all ease-in-out 0.3s;\n  z-index: 1;\n\n\n  &::after {\n    content: '';\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: 0;\n    background-color: #FD8CA9;\n    width: 100%;\n    height: 100%;\n    transition: all ease-in-out 0.5s;\n    z-index: 2;\n  }\n\n  &:hover::after {\n    opacity: 0.7;\n  }\n\n  &:hover {\n    .our-products-text {\n      top: 50%;\n      bottom: 30%;\n      transform: translateY(-50%);\n    }\n  }\n\n  .our-products-img {\n    position: relative;\n    transition: all ease-in-out 0.5s;\n  }\n\n  .our-products-text {\n    position: absolute;\n    bottom: 14%;\n    color: #FFF;\n    font-size: clamp(1.25rem, 0.3571rem + 2.381vw, 2.5rem);\n    font-weight: 300;\n    text-transform: uppercase;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: CENTER;\n    gap: 15px;\n    z-index: 10;\n    transform: translateY(50%);\n    top: 90%;\n    transition: all ease-in-out 0.5s;\n    @media (max-width: 600px) {\n      justify-content: flex-end;\n      padding-right: 10%;\n      font-size: clamp(1.5625rem, 0.4911rem + 5.3571vw, 2.5rem);\n    }\n\n    svg {\n      width: clamp(1.25rem, 0.3571rem + 2.381vw, 2.5rem);\n    }\n  }\n}\n\n\n//.our-products-block {\n//  padding: 50px 20px;\n//  max-width: 1440px;\n//  margin: 0 auto;\n//\n//\n//  .our-products-items {\n//    display: flex;\n//    justify-content: flex-end;\n//    @media (max-width: 600px) {\n//      flex-direction: column;\n//    }\n//\n//    .our-products-title-block {\n//\n//      .text {\n//        height: 80vh;\n//        width: clamp(13.75rem, 10.5357rem + 16.0714vw, 25rem);\n//        display: flex;\n//        justify-content: center;\n//        align-items: center;\n//        @media (max-width: 600px) {\n//          margin-bottom: 40px;\n//          width: 100%;\n//          height: auto;\n//          text-align: center;\n//        }\n//\n//        .our-products-title {\n//          color: #4D4D4D;\n//          font-size: clamp(1.5rem, 1.0357rem + 2.3214vw, 3.125rem);\n//          font-weight: 400;\n//          transform: translateY(100px) rotate(-90deg);\n//          @media (max-width: 600px) {\n//            transform: none;\n//            position: relative;\n//          }\n//\n//          &:after {\n//            content: \"\";\n//            height: 9px;\n//            width: 300px;\n//            display: block;\n//            background: #B0D404;\n//            position: absolute;\n//            top: 41%;\n//            left: 100%;\n//            transform: translateX(45px);\n//\n//            @media (max-width: 600px) {\n//              content: \"\";\n//              display: block;\n//              width: clamp(4.1875rem, 2.7946rem + 6.9643vw, 9.0625rem);\n//              height: 9px;\n//              background-color: #B0D404;\n//              position: absolute;\n//              top: -10px;\n//              left: 50%;\n//              right: 50%;\n//              transform: translate(-50%, -50%);\n//            }\n//          }\n//        }\n//      }\n//\n//      .our-products-text {\n//        top: 80%;\n//      }\n//    }\n//  }\n//}\n//\n//.our-products-title {\n//  display: flex;\n//  //flex-wrap: wrap;\n//  gap: 30px;\n//  margin-bottom: 30px;\n//  @media (max-width: 600px) {\n//    padding: 0 30px;\n//  }\n//  @media (max-width: 996px) {\n//    flex-wrap: nowrap;\n//    flex-direction: column;\n//    margin-bottom: 0;\n//  }\n//\n//  .our-products-img-item {\n//    max-height: 762px;\n//    max-width: 712px;\n//    flex: 1 1 45%;\n//\n//    .our-products-img {\n//      height: 100%;\n//      width: 100%;\n//      object-fit: cover;\n//\n//    }\n//  }\n//}\n//\n////.bottom-item {\n////  //max-height: 350px;\n////  max-width: 100%;\n////  //flex: 1 3 100%;\n////  @media (max-width: 996px) {\n////    margin-top: 30px;\n////    max-height: 762px;\n////    max-width: 712px;\n////  }\n////\n////  .our-products-title {\n////    max-width: 100%;\n////    width: 100%;\n////    height: clamp(11.25rem, 5.8929rem + 14.2857vw, 18.75rem);\n////    object-fit: cover;\n////    margin-bottom: 0;\n////    @media (max-width: 996px) {\n////      height: 100%;\n////      width: 100%;\n////    }\n////  }\n////}\n//\n//\n//.our-products-img-item {\n//  position: relative;\n//  cursor: pointer;\n//  transition: all ease-in-out 0.3s;\n//  z-index: 1;\n//\n//  &::after {\n//    content: '';\n//    display: block;\n//    position: absolute;\n//    top: 0;\n//    left: 0;\n//    opacity: 0;\n//    background-color: #FD8CA9;\n//    width: 100%;\n//    height: 100%;\n//    transition: all ease-in-out 0.5s;\n//    z-index: 2;\n//  }\n//\n//  &:hover::after {\n//    opacity: 0.7;\n//  }\n//\n//  &:hover {\n//    .our-products-text {\n//      top: 50%;\n//      bottom: 30%;\n//      transform: translateY(-50%);\n//    }\n//  }\n//\n//  .our-products-img {\n//    position: relative;\n//    transition: all ease-in-out 0.5s;\n//  }\n//\n//  .our-products-text {\n//    position: absolute;\n//    bottom: 14%;\n//    color: #FFF;\n//    font-size: 25px;\n//    font-weight: 300;\n//    text-transform: uppercase;\n//    width: 100%;\n//    display: flex;\n//    justify-content: center;\n//    align-items: CENTER;\n//    gap: 15px;\n//    z-index: 10;\n//    transform: translateY(50%);\n//    top: 90%;\n//    transition: all ease-in-out 0.5s;\n//    @media (max-width: 600px) {\n//      justify-content: flex-end;\n//      padding-right: 10%;\n//    }\n//\n//    svg {\n//      width: 25px;\n//    }\n//  }\n//}\n",".title-header {\n  color: #000;\n  font-family: \"Inter\", sans-serif;\n  font-size: clamp(1.25rem, 0.8036rem + 2.2321vw, 2.8125rem);\n  padding: 40px 60px;\n  position: relative;\n  //text-align: center;\n  display: inline-block;\n  font-weight: 700;\n  @media (max-width: 600px) {\n    text-align: center;\n    width: 100%;\n    padding: 40px 0;\n  }\n\n\n  &::before {\n    content: '';\n    display: block;\n    width: clamp(4.1875rem, 2.7946rem + 6.9643vw, 9.0625rem);\n    height: 5px;\n    background-color: #B0D404;\n    position: absolute;\n    top: 30px;\n    left: 50%;\n    right: 50%;\n    transform: translate(-50%, -50%);\n  }\n}\n\n.special-order {\n  .special-order-block-bg {\n    background: #fff;\n    outline: none;\n    padding-bottom: 80px;\n\n  }\n\n  .slick-slider{\n\n    .slick-list{\n      margin: -10px 0;\n      .slick-track{\n        .slick-slide  {\n          display: grid;\n          place-items: center;\n          //margin: 20px 0;\n          & > div{\n            padding:  10px 0;\n          }\n        }\n      }\n    }\n    .slick-dots {\n      bottom: -35px;\n    }\n  }\n}\n\n\n\n\n\n\n\n//\n//\n//\n//  .special-order-bg {\n//    height: 470px;\n//    padding: 25px 20px 35px 20px;\n//    display: flex !important;\n//    flex-direction: column;\n//    justify-content: center;\n//    align-items: center; // Center horizontally\n//    gap: 16px;\n//    border-radius: 20px;\n//    border: 1px solid #B7B5B5;\n//    outline: none;\n//    margin-top: 30px;\n//\n//    @media (max-width: 480px) {\n//      width: 100% !important;\n//    }\n//\n//    img {\n//      background-color: #F8F8F8;\n//      border-radius: 16px;\n//      width: 253px;\n//      height: 244px;\n//      max-width: 100%;\n//      object-fit: cover;\n//      cursor: pointer;\n//    }\n//\n//    .special-order-title {\n//      padding: 0 35px;\n//      color: #000;\n//      text-align: center;\n//      font-size: 16px;\n//      font-weight: 600;\n//      line-height: 26px;\n//      text-transform: capitalize;\n//    }\n//\n//    .special-order-text {\n//      display: flex;\n//      justify-content: center;\n//      align-items: center;\n//      gap: 10px;\n//\n//      p {\n//        font-size: 16px;\n//        font-weight: 400;\n//        line-height: 26px; /* 162.5% */\n//        letter-spacing: 0.8px;\n//        text-transform: uppercase;\n//      }\n//\n//      .special-order-old-price {\n//        color: #939393;\n//        text-decoration-line: line-through;\n//      }\n//\n//      .special-order-new-price {\n//        color: #F23969;\n//        font-weight: 500;\n//      }\n//    }\n//\n//    button {\n//      padding: 10px 50px;\n//    }\n//\n//    //.special-order-btn-block {\n//    //  display: flex;\n//    //  gap: 20px;\n//    //  justify-content: space-between;\n//    //\n//    //  .add-btn {\n//    //    width: 100%;\n//    //    border-radius: 8px;\n//    //    background: #B0D404;\n//    //    //padding: 10px;\n//    //    color: #fff;\n//    //    border: none;\n//    //    font-size: 22px;\n//    //    font-weight: 500;\n//    //  }\n//    //\n//    //  .like-btn {\n//    //    width: 150px;\n//    //    border-radius: 8px;\n//    //    background: #EEE;\n//    //    padding: 10px 0px;\n//    //    border: none;\n//    //  }\n//    //}\n//  }\n//}",".our-partners-block-title {\n    text-align: center;\n    color: #000;\n    font-family: \"Inter\";\n    font-size: 35px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    margin-bottom: 20px;\n}\n.our-partners-bg{\n    background: #fff;\n    width: 80% !important;\n    height: 118px;\n    display: flex !important;\n    justify-content: center;\n    align-items: center;\n    @media (max-width:480px){\n        width:100% !important\n    }\n}",".our-client-opinion {\n  background: #FD8CA9;\n  text-align: center;\n  padding: 45px 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  pointer-events: revert;\n  position: relative;\n\n  .slick-dots {\n\n    li {\n      width: 15px;\n      height: 15px;\n      background-color: #fff;\n      border: 1px solid #fff;\n      border-radius: 50%;\n\n      button {\n        &::before {\n          font-size: 0;\n        }\n      }\n    }\n\n    .slick-active {\n      background-color: transparent;\n    }\n  }\n\n  .slick-prev,\n  .slick-next {\n    top: calc(50% - 50px);\n  }\n\n  .our-client-opinion-block-title {\n    color: #FFF;\n    text-align: center;\n    font-family: $robotoFont;\n    font-size: clamp(1.5rem, -1.1667rem + 13.3333vw, 2.5rem);\n    text-transform: capitalize;\n    padding: 0 15px;\n  }\n\n  .our-client-opinion-block-bg {\n    width: 80%;\n    margin-top: 50px;\n\n    .our-client_opinion-bg {\n      //margin: 30px 0;\n\n\n      .our-client_slider-text {\n        width: 80%;\n        padding: 0 10px;\n        margin: 0 auto;\n        @media (max-width: 600px) {\n          width: 100%;\n        }\n\n        p {\n          color: #FFF;\n          font-family: $robotoFont;\n          font-size: 19px;\n          line-height: 26px;\n        }\n\n        .our-client_slider-description {\n          font-size: clamp(0.875rem, 0.0417rem + 4.1667vw, 1.1875rem);\n        }\n\n        .our-client_user-name {\n          margin-top: 25px;\n        }\n      }\n    }\n  }\n}",".our-client-opinion-block-bg {\n    .slick-arrow.slick-prev:before{\n        content: '' !important;\n    }\n}",".our-client-opinion-block-bg{\n    .slick-next.slick-next::before{\n        content: '' !important;\n    }\n\n \n}\n",".categrias-item-mine-block{\n    display: flex;\n    justify-content: space-around;\n    width: 80%;\n\n    margin: auto;\n    border: 1px solid red;\n\n    .categrias-item-mine-block-slide,\n    .categrias-item-mine-block-info{\n        width: 48%;\n        border: 1px solid green;\n\n    }\n\n    \n}",".payment {\r\n  //max-width: 1440px;\r\n\r\n  .payment-method {\r\n    padding: clamp(1.25rem, -0.5793rem + 9.1463vw, 3.125rem) 15px;\r\n    border-bottom: 1px solid #C0C0C0;\r\n\r\n\r\n    .payment-method_form {\r\n      display: flex;\r\n      justify-content: center;\r\n      flex-wrap: wrap;\r\n      gap: clamp(1.25rem, 0.7143rem + 2.6786vw, 3.125rem);\r\n\r\n      @media(max-width: 648px) {\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n        align-content: center;\r\n      }\r\n\r\n\r\n      .payment-method_label {\r\n        display: flex;\r\n        gap: 10px;\r\n        align-items: center;\r\n        cursor: pointer;\r\n\r\n        img {\r\n          width: 100px;\r\n        }\r\n\r\n        .payment-name {\r\n          font-size: 16px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .payment-order {\r\n    padding: 60px 20px;\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: clamp(1.25rem, -0.1786rem + 7.1429vw, 6.25rem);\r\n\r\n    @media (max-width: 769px) {\r\n      flex-wrap: wrap;\r\n      padding: 15px 15px 30px 15px;\r\n    }\r\n\r\n    .my-order {\r\n      padding: 20px 0;\r\n\r\n      h3 {\r\n        margin-bottom: 30px;\r\n        color: #000;\r\n        font-size: 24px;\r\n        font-weight: 500;\r\n        text-transform: capitalize;\r\n      }\r\n\r\n      .my-order_lists-group {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 20px;\r\n\r\n        .my-order_list {\r\n          display: flex;\r\n          gap: 20px;\r\n          align-items: center;\r\n\r\n          .order-img {\r\n            max-width: 100%;\r\n            width: 90px;\r\n          }\r\n\r\n          .order-inner {\r\n            display: flex;\r\n            flex-direction: column;\r\n            gap: 10px;\r\n\r\n            .order_name {\r\n              color: #B2B2B2;\r\n              font-size: 16px;\r\n              font-weight: 700;\r\n              letter-spacing: 0.8px;\r\n            }\r\n\r\n            .order_title-name {\r\n              color: #000;\r\n              font-size: 16px;\r\n              font-style: normal;\r\n              font-weight: 500;\r\n              line-height: 23px;\r\n            }\r\n\r\n            .order-price {\r\n              display: flex;\r\n              align-items: center;\r\n              gap: 10px;\r\n              font-size: 16px;\r\n              letter-spacing: 0.8px;\r\n              text-transform: uppercase;\r\n\r\n              .order_price-discount {\r\n                color: #939393;\r\n              }\r\n\r\n              .order_price-count {\r\n                color: #F23969;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .order-divider {\r\n      width: 1px;\r\n      height: auto;\r\n      background: #A2A2A2;;\r\n      @media (max-width: 769px) {\r\n        width: 100%;\r\n        height: 1px;\r\n      }\r\n    }\r\n\r\n    .order-summary {\r\n      padding: 20px 0;\r\n      width: 360px;\r\n\r\n      h3 {\r\n        margin-bottom: 30px;\r\n        color: #000;\r\n        font-size: 24px;\r\n        font-weight: 500;\r\n        text-transform: capitalize;\r\n      }\r\n\r\n      .order-summary_inner {\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: space-between;\r\n        gap: 30px;\r\n        height: calc(100% - 40px);\r\n\r\n        .summary-title {\r\n          display: flex;\r\n          flex-direction: column;\r\n          justify-content: space-between;\r\n          gap: 15px;\r\n          width: 100%;\r\n\r\n          .summary_inner {\r\n            display: flex;\r\n            justify-content: space-between;\r\n\r\n            .subtotal-text {\r\n              color: #999;\r\n              font-size: 16px;\r\n              font-weight: 500;\r\n            }\r\n\r\n            .subtotal-price {\r\n              font-size: 16px;\r\n              font-weight: 500;\r\n            }\r\n\r\n            .summary_total-price {\r\n              color: #F56E91;\r\n              font-size: 24px;\r\n              font-weight: 700;\r\n            }\r\n          }\r\n\r\n          .summary-divider {\r\n            width: 100%;\r\n            height: 1px;\r\n            background-color: #A2A2A2;\r\n            margin: 20px 0;\r\n          }\r\n        }\r\n      }\r\n\r\n      .summary-button {\r\n        display: flex;\r\n        justify-content: flex-end;\r\n        gap: 30px;\r\n\r\n\r\n        button {\r\n          font-size: 20px;\r\n          font-weight: 500;\r\n          border-radius: 8px;\r\n          border: none;\r\n          padding: 10px 25px;\r\n          cursor: pointer;\r\n          width: 100%;\r\n        }\r\n\r\n        .cancel-btn {\r\n          color: #8E8E8E;\r\n\r\n          border: 1px solid #C2C2C2;\r\n        }\r\n\r\n        .buy-btn {\r\n          color: #fff;\r\n          border-radius: 8px;\r\n          background: #B0D404;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .policy-text {\r\n    text-align: center;\r\n    max-width: 580px;\r\n    margin: 0 auto;\r\n    padding: 0 20px;\r\n    color: #757575;\r\n    font-size: 14px;\r\n    text-transform: capitalize;\r\n    line-height: 23px;\r\n\r\n    a {\r\n      text-decoration-line: underline;\r\n    }\r\n  }\r\n}\r\n\r\n.order-message {\r\n  position: absolute;\r\n  width: 400px;\r\n  height: 200px;\r\n  background: #b0d404;\r\n  color: #fff;\r\n  left: 50%;\r\n  right: 50%;\r\n  top: 50%;\r\n  transform: translate(-50%, -50%);\r\n  font-size: 30px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 26px;\r\n  text-align: center;\r\n  letter-spacing: 2px;\r\n}",".cart_table-section {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n\n  .table_form {\n    max-width: 1440px;\n    padding-bottom: 20px;\n\n    .cart_table {\n      margin: 0 auto;\n      border-collapse: collapse;\n      padding: 0;\n      width: 100%;\n    }\n\n    .cart_head {\n      height: 64px;\n    }\n\n    .cart_title {\n      border-bottom: 1px solid #cdcdcd;\n\n      th {\n        text-align: center;\n        color: #000;\n        font-size: 16px;\n        letter-spacing: 0.8px;\n        text-transform: capitalize;\n      }\n    }\n  }\n\n  @media(max-width: 768px) {\n    tbody.item-body {\n      display: flex;\n      gap: 30px;\n      flex-wrap: wrap;\n    }\n  }\n\n  @media(max-width: 640px) {\n    tbody.item-body {\n      display: block;\n    }\n    .responsiveTable td .tdBefore {\n      display: block;\n    }\n    .responsiveTable tbody tr {\n      //border: none;\n    }\n    .responsiveTable td.pivoted {\n      //padding-left: calc(38% + 10px) !important;\n      display: flex;\n      align-items: center;\n    }\n    tr.item {\n      display: flex;\n      flex-wrap: wrap;\n      margin-bottom: 20px;\n      border: none;\n      border-bottom: 1px solid #8E8E8E;\n\n    }\n    .item .item_description .item_title {\n      display: flex;\n      flex-direction: column;\n      gap: 15px;\n      width: 100%;\n      @media (max-width: 420px) {\n        display: none\n      }\n    }\n    .tdBefore {\n      font-size: 15px;\n    }\n  }\n}\n\n\n.item_description {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n  //padding: 25px 0;\n\n  .item_img {\n    padding: 15px;\n    border-radius: 16px;\n    background: #F8F8F8;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    img {\n      width: 190px;\n      height: 140px;\n      max-width: 100%;\n      object-fit: cover;\n    }\n  }\n\n  .item_title {\n    display: flex;\n    justify-content: space-evenly;\n    flex-direction: column;\n    gap: 20px;\n    @media (max-width: 850px) {\n      display: none;\n    }\n    @media (max-width: 768px) {\n      gap: 10px;\n      align-items: center;\n      display: flex;\n    }\n    @media (max-width: 640px) {\n      gap: 10px;\n      align-items: flex-start;\n    }\n\n    .item_text {\n      color: #000;\n      font-size: 16px;\n      font-weight: 500;\n    }\n\n    .item-count {\n      color: #F23969;\n      font-size: 16px;\n      font-weight: 500;\n      letter-spacing: 0.8px;\n      text-transform: uppercase;\n\n      span {\n        color: #939393;\n        font-size: 16px;\n        letter-spacing: 0.8px;\n        text-decoration-line: line-through;\n        text-transform: uppercase;\n        padding-right: 20px;\n      }\n    }\n  }\n}\n\n\n.item_input {\n  .btn-group {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  button {\n    padding: 0 12px;\n    border-radius: 8px;\n    background: #F2F2F2;\n    border: none;\n    font-size: 24px;\n    cursor: pointer;\n    width: 30px;\n    height: 30px;\n\n  }\n\n  .item_quantityCount {\n    margin: 0 10px;\n    font-size: 20px;\n  }\n}\n\n.item_subtotal {\n  font-size: 18px;\n  font-weight: 700;\n  letter-spacing: 0.9px;\n  text-transform: uppercase;\n}\n\n.item_date {\n  input {\n    width: 152px;\n    height: 44px;\n    padding: 15px;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 10px;\n    border-radius: 8px;\n    background: #F6F6F6;\n    border: none;\n    cursor: pointer;\n  }\n}\n\n.item_action {\n  button {\n    padding: 12px 18px;\n    border-radius: 8px;\n    background: #F6F6F6;\n    font-size: 18px;\n    border: none;\n    cursor: pointer;\n    transition: background-color ease-in-out .3s;\n\n    &:hover {\n      background-color: #F23969;\n\n    }\n  }\n}\n\n\ntd {\n  text-align: center;\n  //padding: 24px 35px;\n\n  &:nth-child(1) {\n    text-align: left;\n  }\n\n}\n\n.cart_title {\n  th {\n    padding: 0 60px;\n    @media (max-width: 1135px) {\n      padding: 0 35px;\n    }\n    @media (max-width: 996px) {\n      padding: 0 17px;\n    }\n  }\n}\n\n@media (max-width: 996px) {\n  th:nth-child(5) {\n    padding: 0;\n  }\n  .cart_table-section {\n    max-width: 92%;\n    margin: 0 auto;\n\n  }\n}\n\n\n.cart_btn-group {\n  display: flex;\n  justify-content: flex-end;\n  gap: 32px;\n  width: 88%;\n  @media (max-width: 1310px) {\n    width: 96%;\n  }\n  @media (max-width: 960px) {\n    width: 100%;\n  }\n  @media (max-width: 620px) {\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    margin-top: 20px;\n    gap: 20px;\n  }\n\n\n  button {\n    padding: 10px 25px;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n\n    @media(max-width: 500px) {\n      font-size: 20px;\n    }\n  }\n\n  .cart_cancel {\n    color: #8E8E8E;\n    border: 1px solid #C2C2C2;\n    background: #fff;\n\n  }\n\n  .cart_buy {\n    background: #B0D404;\n    color: #fff;\n    border: none;\n  }\n}\n\n.cart_table-md {\n  display: none;\n}\n\n@media (max-width: 890px) {\n\n  .item_img {\n    padding: 10px;\n  }\n\n  .cart_table-md {\n    display: block;\n    max-width: 100%;\n    margin: 0 auto;\n  }\n  .table_md-item {\n    border-bottom: 1px solid #cdcdcd;\n    padding-bottom: 40px;\n\n    h4 {\n      color: #000;\n      font-size: 16px;\n      letter-spacing: 0.8px;\n      text-transform: capitalize;\n      margin: 15px 0;\n    }\n\n\n    .md_item-desc {\n      display: flex;\n      align-items: flex-start;\n      gap: 15px;\n      @media(max-width: 620px) {\n        flex-direction: column;\n        align-items: center;\n      }\n\n      p {\n        color: #000;\n        font-size: 18px;\n        letter-spacing: 0.8px;\n        text-transform: capitalize;\n      }\n\n\n      .md_item-title {\n        width: 264px;\n\n        .item_img {\n          width: 264px;\n          height: 259px;\n          padding: 20px;\n          border-radius: 16px;\n          background: #F8F8F8;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          @media(max-width: 620px) {\n            width: 100%;\n            height: 100%;\n            padding: 20px;\n          }\n\n          img {\n            max-width: 100%;\n            object-fit: cover;\n\n          }\n        }\n\n        .md_item-text {\n          font-size: 16px;\n          font-weight: 500;\n          line-height: 24px;\n          margin: 22px 0;\n        }\n\n        .md-item-price {\n          color: #F23969;\n          font-size: 16px;\n          font-weight: 500;\n          letter-spacing: 0.8px;\n          text-transform: uppercase;\n\n          span {\n            color: #939393;\n            letter-spacing: 0.8px;\n            text-decoration-line: line-through;\n            text-transform: uppercase;\n            margin-right: 25px;\n          }\n        }\n      }\n    }\n  }\n  .md_item-info {\n    display: flex;\n    gap: 35px;\n    align-items: center;\n\n    .md_quantity,\n    .md_subtitle,\n    .md_delivery-date,\n    .md_action {\n      gap: 50px;\n      display: flex;\n      align-items: center;\n    }\n\n    .md_item-title-info {\n      display: flex;\n      flex-direction: column;\n      gap: 40px;\n      @media(max-width: 620px) {\n        gap: 20px;\n      }\n\n    }\n\n    .md_item-title-subtotal {\n      font-size: 18px;\n      font-weight: 700;\n      letter-spacing: 0.9px;\n      text-transform: uppercase;\n    }\n\n    .md_item-title-date {\n      input {\n        padding: 15px;\n        border-radius: 8px;\n        background: #F6F6F6;\n        font-size: 15px;\n        border: none;\n      }\n    }\n\n    .md_item-title-action {\n      button {\n        padding: 12px 18px;\n        border-radius: 8px;\n        background: #F6F6F6;\n        font-size: 18px;\n        border: none;\n        cursor: pointer;\n      }\n    }\n  }\n}\n\n.md_item-title-quantity {\n  button {\n    padding: 0 12px;\n    border-radius: 8px;\n    background: #F2F2F2;\n    border: none;\n    font-size: 24px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n  }\n\n  .item_quantityCount {\n    margin: 0 10px;\n    font-size: 20px;\n  }\n}\n\n@media (max-width: 768px) {\n  .responsiveTable td .tdBefore {\n    display: block !important;\n  }\n  .cart_table-section {\n    overflow-x: auto;\n  }\n\n  .cart_head {\n    display: none;\n  }\n\n  .cart_title {\n    display: block;\n    position: sticky;\n    top: 0;\n    background-color: #fff;\n    z-index: 1;\n  }\n\n  .cart_title th {\n    padding: 10px;\n  }\n\n  .item {\n    display: block;\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .item td {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 20px;\n    text-align: left;\n    padding: 10px;\n  }\n\n  .item_description {\n    flex-direction: column;\n    align-items: flex-start;\n\n    .item_img {\n      width: 100%;\n      padding: 15px 0;\n    }\n\n    .item_title {\n      padding: 15px 0;\n    }\n  }\n\n  .item_input {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 0;\n\n    .btn-group {\n      gap: 10px;\n    }\n\n    button {\n      padding: 0;\n    }\n\n    .item_quantityCount {\n      margin: 0;\n    }\n  }\n\n  .item_subtotal,\n  .item_date,\n  .item_action {\n    padding: 10px 0;\n  }\n\n  .cart_btn-group {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n.input-title {\n  background-color: #F8F8F8;\n\n  .input-group {\n    max-width: 1440px;\n    margin: 0 auto;\n    padding: 50px 0;\n    display: flex;\n    flex-direction: column;\n    gap: 35px;\n\n    .input-group_items {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: space-evenly;;\n      gap: 30px;\n      @media (max-width: 768px) {\n        flex-direction: column;\n        align-items: center;\n      }\n\n      .input-inner-group {\n        width: 30%;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        gap: 30px;\n        @media (max-width: 768px) {\n          width: 100%;\n          padding: 0 5%;\n        }\n\n        .input-item {\n          display: flex;\n          flex-direction: column;\n          gap: 10px;\n          height: 100%;\n\n          .label {\n            font-family: 'Inter', 'sans-serif';\n            font-size: 15px;\n            letter-spacing: 0.75px;\n          }\n\n          input[type=number]::-webkit-inner-spin-button,\n          input[type=number]::-webkit-outer-spin-button {\n            -webkit-appearance: none;\n            margin: 0;\n          }\n\n          input[type=number] {\n            -moz-appearance: textfield; /* Firefox */\n          }\n\n          input {\n            border-radius: 8px;\n            border: 1px solid #CDCDCD;\n            background: #FFF;\n            padding: 20px 16px;\n            outline: none;\n\n            &::placeholder {\n              color: #7E7E7E;\n              font-family: 'Inter', 'sans-serif';\n              font-size: 16px;\n              text-transform: capitalize;\n            }\n          }\n\n          textarea {\n            padding: 20px 16px;\n            border-radius: 8px;\n            outline: none;\n            resize: none;\n            border: 1px solid #CDCDCD;\n            height: 100%;\n            font-family: \"Inter\", sans-serif;\n\n            &::placeholder {\n              color: #7E7E7E;\n              font-family: 'Inter', 'sans-serif';\n              font-size: 16px;\n              text-transform: capitalize;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.empty-cart {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 20px;\n  padding: 50px 0;\n  min-height: 500px;\n\n  p {\n    color: #958D8D;\n    font-size: 24px;\n    letter-spacing: 1.2px;\n    text-transform: capitalize;\n  }\n\n  svg {\n    max-width: 100%;\n  }\n}","footer {\n  background-color: #0B0B0B;\n  padding: 50px 0;\n  color: #fff;\n  @media(max-width: 500px) {\n    padding: 50px 0;\n  }\n\n  .footer_title {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 30px;\n    max-width: 1400px;\n    padding: 0 100px;\n    margin: 0 auto;\n    @media(max-width: 500px) {\n      padding: 0 20px;\n      gap: 20px;\n    }\n\n    @media(max-width: 729px) {\n      justify-content: center;\n    }\n\n    .social {\n      max-width: 250px;\n\n      .social_logo {\n        position: relative;\n\n        .social_link {\n          font-size: 18px;\n          font-weight: 500;\n          line-height: 20px;\n          text-transform: uppercase;\n\n          img {\n            width: 83px;\n            position: absolute;\n            left: -93px;\n            top: -10px;\n            @media(max-width: 500px) {\n              right: 0;\n              top: 0;\n              left: 180px;\n            }\n          }\n        }\n      }\n\n      .social_text {\n        margin: 30px 0;\n        font-size: 12px;\n        line-height: 16px;\n\n      }\n\n      .social_icons {\n        display: flex;\n        gap: 20px;\n      }\n    }\n\n\n    .footer-contact {\n      //max-width: 250px;\n\n      @media(max-width: 650px) {\n        width: 250px;\n      }\n\n      .contact_title {\n        font-weight: 500;\n        line-height: normal;\n        margin-bottom: 30px;\n\n        &::before {\n          content: '';\n          border-left: 2px solid #B0D404;\n          height: 100%;\n          width: 2px;\n          padding-left: 10px;\n        }\n      }\n\n      li {\n        margin-bottom: 15px;\n        font-size: 12px;\n\n        &::marker {\n          color: #F56E91;\n          font-size: 14px;\n        }\n      }\n    }\n\n    .newsletter {\n      max-width: 250px;\n\n      .newsletter_title {\n        font-weight: 500;\n        line-height: normal;\n        margin-bottom: 30px;\n\n        &::before {\n          content: '';\n          border-left: 2px solid #B0D404;\n          height: 100%;\n          width: 2px;\n          padding-left: 10px;\n        }\n      }\n\n      .newsletter_text {\n        font-size: 12px;\n        line-height: 16px;\n        margin: 20px 0;\n\n      }\n\n      .newsletter_input {\n        display: flex;\n        align-items: center;\n        position: relative;\n\n        input {\n          width: 100%;\n          height: 40px;\n          background: rgba(188, 188, 188, 0.30);\n          color: rgba(228, 228, 228, 0.90);\n          border: none;\n          border-radius: 25px;\n          padding: 0 15px;\n          outline: none;\n\n          @media (max-width: 634px) {\n            background-color: #BCBCBC;\n            color: #2B2B2B;\n\n          }\n        }\n\n\n        button {\n          position: absolute;\n          right: 10px;\n          background: transparent;\n          border: none;\n          cursor: pointer;\n\n        }\n      }\n    }\n  }\n}",".form {\r\n  .pass_description {\r\n    width: 100%;\r\n    color: #676767;\r\n    font-size: clamp(0.875rem, 0.8393rem + 0.1786vw, 1rem);\r\n    font-weight: 400;\r\n    line-height: 22px;\r\n    letter-spacing: 0.8px;\r\n    margin-top: 17px;\r\n    text-align: justify;\r\n  }\r\n\r\n\r\n  .btn_sign {\r\n    color: #fff;\r\n    border: none;\r\n    height: 50px;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n    background-color: rgb(245, 110, 145);\r\n    margin-top: 20px;\r\n\r\n  }\r\n}\r\n\r\n\r\n@media (max-width: 610px) {\r\n  .signup_panel {\r\n    width: 100%;\r\n    padding: 20px;\r\n\r\n    .form {\r\n      width: 100%;\r\n\r\n      .labels {\r\n        .input_box {\r\n          input {\r\n            width: 100%;\r\n            padding: 10px;\r\n            margin: 10px 0;\r\n          }\r\n        }\r\n\r\n        .input_box_pass {\r\n          .pass_eye {\r\n            input {\r\n              width: 100%;\r\n            }\r\n          }\r\n        }\r\n\r\n        .pass_description {\r\n          width: 100%;\r\n        }\r\n      }\r\n\r\n      .btn_sign {\r\n        width: 100%;\r\n      }\r\n    }\r\n  }\r\n}\r\n",".signIn_panel,\r\n.signup_panel {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 35px 45px;\r\n  border-radius: 16px;\r\n  background: #fff;\r\n  width: 500px;\r\n  max-width: 100%;\r\n\r\n  @media (max-width: 560px) {\r\n    padding: 20px 25px;\r\n  }\r\n\r\n  h2 {\r\n    font-size: 24px;\r\n    font-weight: 700;\r\n    line-height: 28px;\r\n    letter-spacing: 0.05em;\r\n    text-transform: uppercase;\r\n  }\r\n\r\n  .form {\r\n    display: flex;\r\n    margin: 15px 0;\r\n    flex-direction: column;\r\n\r\n    //.input_box {\r\n    .input-box_title {\r\n      font-size: 16px;\r\n      font-weight: 500;\r\n      letter-spacing: 0.8px;\r\n      margin: 20px 0;\r\n    }\r\n\r\n\r\n    .singIn-input_error {\r\n      border-color: red;\r\n    }\r\n\r\n    .error-text {\r\n      color: red;\r\n      margin: 5px 0 0 15px;\r\n    }\r\n\r\n    //}\r\n\r\n    .input_box {\r\n\r\n      .passEye {\r\n        position: relative;\r\n\r\n        .eye {\r\n          position: absolute;\r\n          top: 20px;\r\n          right: 20px;\r\n          cursor: pointer;\r\n        }\r\n      }\r\n    }\r\n\r\n    .reset_link {\r\n      display: flex;\r\n      justify-content: end;\r\n\r\n      p {\r\n        color: #676767;\r\n        font-size: 16px;\r\n        font-weight: 400;\r\n        line-height: 22px;\r\n        letter-spacing: 0.8px;\r\n        margin-top: 17px;\r\n        cursor: pointer;\r\n      }\r\n    }\r\n\r\n    .logIn {\r\n      display: flex;\r\n      color: #fff;\r\n      border: none;\r\n      height: 50px;\r\n      justify-content: center;\r\n      align-items: center;\r\n      border-radius: 8px;\r\n      cursor: pointer;\r\n      font-size: 16px;\r\n      background-color: rgba(245, 110, 145, 1);\r\n      margin-top: 32px;\r\n\r\n      &:hover {\r\n        background-color: #f56e91;\r\n      }\r\n    }\r\n  }\r\n\r\n  .text-input {\r\n    display: flex;\r\n    width: 100%;\r\n    height: 50px;\r\n    padding: 10px 20px;\r\n    border-radius: 8px;\r\n    border: 1px solid #a2a2a2;\r\n    color: rgba(0, 0, 0, 1);\r\n    outline: none;\r\n    font-size: 18px;\r\n  }\r\n\r\n  .text-input_error {\r\n    border-color: red;\r\n  }\r\n\r\n\r\n  .line {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    hr {\r\n      width: 170px;\r\n      height: 1px;\r\n      color: rgba(162, 162, 162, 1);\r\n    }\r\n\r\n    .or {\r\n      display: flex;\r\n      width: 35px;\r\n      height: 27px;\r\n      justify-content: center;\r\n      align-items: center;\r\n      border-radius: 8px;\r\n      border: 1px solid #a2a2a2;\r\n      color: rgba(162, 162, 162, 1);\r\n      padding: 0 30px;\r\n    }\r\n  }\r\n\r\n  .icons_ul {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-top: 15px;\r\n    gap: 40px;\r\n    list-style: none;\r\n\r\n    .icons_url {\r\n      cursor: pointer;\r\n    }\r\n\r\n  }\r\n\r\n  .signIn_footer {\r\n    p {\r\n      color: #676767;\r\n      font-size: 16px;\r\n      line-height: 22px;\r\n      letter-spacing: 0.8px;\r\n      margin-top: 20px;\r\n      text-align: center;\r\n\r\n      span {\r\n        text-decoration-line: underline;\r\n        cursor: pointer;\r\n        text-transform: uppercase;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n@media (max-width: 610px) {\r\n  .singIn_panel {\r\n    padding: 30px;\r\n\r\n    .form {\r\n      .input_box {\r\n        input {\r\n          width: 100%;\r\n        }\r\n      }\r\n\r\n      .input_box_pass {\r\n        .passEye {\r\n          input {\r\n            width: 100%;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .icons {\r\n      .line {\r\n        hr {\r\n          width: 100%;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n",".reset {\r\n  padding: 35px 40px;\r\n  border-radius: 16px;\r\n  background: #fff;\r\n  width: 500px;\r\n  max-width: 100%;\r\n\r\n  .reset_title {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 20px;\r\n\r\n    .reset_title-arrow {\r\n      cursor: pointer;\r\n    }\r\n\r\n    h2 {\r\n      font-size: clamp(1.0625rem, 0.9375rem + 0.625vw, 1.5rem);\r\n      font-weight: 700;\r\n      letter-spacing: 1.2px;\r\n    }\r\n  }\r\n\r\n  .input_box {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin: 25px 0;\r\n\r\n    .reset_title {\r\n      font-size: 16px;\r\n      font-weight: 500;\r\n      letter-spacing: 0.8px;\r\n      margin-bottom: 11px;\r\n    }\r\n\r\n    .input-box {\r\n      display: flex;\r\n      flex-direction: column;\r\n      margin-bottom: 25px;\r\n      gap: 10px;\r\n\r\n      .input_reset {\r\n        width: 100%;\r\n        display: flex;\r\n        height: 50px;\r\n        padding: 10px 20px;\r\n        align-items: center;\r\n        border-radius: 8px;\r\n        border: 1px solid #a2a2a2;\r\n      }\r\n\r\n      .input_reset-error {\r\n        border-radius: 8px;\r\n        border-color: red;\r\n      }\r\n\r\n      .reset-error {\r\n        color: red;\r\n      }\r\n    }\r\n\r\n\r\n    .btn_reset {\r\n      display: flex;\r\n      height: 50px;\r\n      padding: 10px 20px;\r\n      justify-content: center;\r\n      align-items: center;\r\n      border-radius: 8px;\r\n      background: #f56e91;\r\n      border: none;\r\n      cursor: pointer;\r\n      color: #fff;\r\n      font-size: 16px;\r\n      font-weight: 500;\r\n      width: 100%;\r\n\r\n      P &:hover {\r\n        background-color: rgb(236, 127, 156);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 610px) {\r\n  .reset {\r\n    padding: 30px;\r\n\r\n    .input_box {\r\n      margin: 20px 0;\r\n\r\n      .input_reset {\r\n        width: 100%;\r\n      }\r\n\r\n      .btn_reset {\r\n        width: 100%;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sign-out {\r\n  padding: 22px 25px;\r\n  border-radius: 16px;\r\n  border: 1px solid #b8b8b8;\r\n  background: #fff;\r\n  width: 500px;\r\n  max-width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n\r\n  .log-out {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n\r\n    h4 {\r\n      color: #000;\r\n      font-size: 22px;\r\n      font-weight: 700;\r\n      text-transform: capitalize;\r\n    }\r\n\r\n    span {\r\n      font-size: 22px;\r\n      cursor: pointer;\r\n    }\r\n  }\r\n\r\n  .sign-out_text {\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n  }\r\n\r\n  .input_box {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 20px;\r\n    @media (max-width: 400px) {\r\n      flex-wrap: wrap;\r\n    }\r\n  }\r\n\r\n  .sign-out_btn {\r\n    background-color: #B0D404;\r\n    color: #fff;\r\n    width: 100%;\r\n    font-weight: 500;\r\n    font-size: 16px;\r\n    padding: 10px 20px;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    border: 1px solid #B0D404;\r\n  }\r\n\r\n  .cancel-btn {\r\n    background-color: #fff;\r\n    color: #000;\r\n    border: 1px solid #B0D404;\r\n    transition: all ease-in-out .2s;\r\n\r\n    &:hover {\r\n      background-color: #B0D404;\r\n      color: #FFFFFF;\r\n    }\r\n  }\r\n}\r\n",".ReactModal__Overlay.ReactModal__Overlay--after-open {\r\n  background: rgba(0, 0, 0, 0.7) !important;\r\n  z-index: 100;\r\n\r\n  @media (max-width: 609px) {\r\n    padding: 0;\r\n\r\n  }\r\n\r\n  .ReactModal__Content.ReactModal__Content--after-open {\r\n    @media (max-width: 609px) {\r\n      inset: 0;\r\n      justify-content: center;\r\n      width: 90%;\r\n    }\r\n\r\n    .auth-modal-content {\r\n      width: 500px;\r\n      @media (max-width: 609px) {\r\n        width: 100%;\r\n      }\r\n    }\r\n  }\r\n}\r\n",".contact {\n  display: flex;\n  justify-content: center;\n  gap: 100px;\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 100px 15px;\n  @media (max-width: 998px) {\n    gap: 30px;\n    flex-wrap: wrap;\n  }\n\n  .contact_container {\n    display: flex;\n    justify-content: space-evenly;\n    flex-direction: column;\n    gap: 40px;\n    padding: 65px 50px;\n    background-color: #F8F8FA;\n    max-width: 600px;\n    @media (max-width: 998px) {\n      max-width: 100%;\n      padding: 25px 15px;\n      gap: 20px;\n    }\n\n    .contact_title {\n      font-size: 24px;\n      font-weight: normal;\n    }\n\n    .contact_text {\n      display: flex;\n      flex-direction: column;\n      gap: 20px;\n\n      .text {\n        color: #707070;\n        font-size: 16px;\n        line-height: 28px;\n        text-align: justify;\n        @media (max-width: 610px) {\n          font-size: 14px;\n\n        }\n      }\n    }\n  }\n\n  .form_container {\n    width: 100%;\n\n    .form_title {\n      font-size: 26px;\n      font-weight: 400;\n    }\n\n    .form_message {\n      display: flex;\n      flex-direction: column;\n      gap: 50px;\n      margin-top: 50px;\n\n\n      .labels {\n        display: flex;\n        align-items: center;\n        gap: 50px;\n        @media (max-width: 610px) {\n          flex-wrap: wrap;\n          gap: 20px;\n        }\n\n        .labels-inner {\n          display: flex;\n          flex-direction: column;\n          width: clamp(12.5rem, -1.612rem + 22.6244vw, 18.75rem);\n          @media (max-width: 998px) {\n            width: 100%;\n          }\n\n          p {\n            color: #666;\n            font-size: 16px;\n            @media(max-width: 480px) {\n              font-size: 14px;\n            }\n          }\n\n          input, textarea {\n            border: none;\n            border-bottom: 1px solid #808080;\n            outline: none;\n            padding: 15px 10px 5px 5px;\n          }\n\n\n          textarea {\n            height: 120px;\n            resize: none;\n\n            @media (max-width: 610px) {\n              height: 120px;\n              font-size: 12px;\n            }\n          }\n\n          select {\n            display: flex;\n            flex-direction: column;\n            width: 100%;\n            border: none;\n            background: transparent;\n            border-bottom: 1px solid #808080;\n            padding: 15px 10px 5px 5px;\n            outline: none;\n          }\n        }\n\n        .labels-inner.textarea {\n          width: 100% !important;\n        }\n      }\n    }\n\n    .form-button {\n      width: 100%;\n      display: flex;\n      justify-content: flex-end;\n      @media (max-width: 610px) {\n        justify-content: center;\n      }\n\n      .btn_message {\n        background-color: #B0D404;\n        border-radius: 8px;\n        padding: 10px 24px;\n        border: none;\n        color: #fff;\n        font-size: 22px;\n        font-weight: 500;\n        cursor: pointer;\n\n      }\n    }\n  }\n}\n\n",".not-found {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 30px;\n  padding: 20px 15px;\n\n  .not-fount_text {\n    font-size: clamp(1.125rem, 0.9464rem + 0.8929vw, 1.75rem);\n    font-weight: 500;\n    letter-spacing: 1.4px;\n    text-align: center;\n  }\n\n  button {\n    border-radius: 8px;\n    background: #B0D404;\n    padding: 10px 50px;\n    color: #fff;\n    border: none;\n    font-size: 22px;\n    font-weight: 700;\n    cursor: pointer;\n    text-transform: capitalize;\n\n  }\n}",".user-table_image {\n  width: 80px;\n}",".slides-box {\n  background-color: #fff;\n  border-radius: 15px;\n  display: flex;\n  flex-direction: column;\n  //justify-content: center;\n  //align-items: center;\n  gap: 20px;\n  padding: 15px;\n  width: 100%;\n}\n\n.add-image {\n  width: 210px;\n\n  //.btn-group {\n  //  display: flex;\n  //  justify-content: space-between;\n  //}\n}\n\n.all-images {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  padding: 0 20px;\n  @media (max-width: 490px) {\n    justify-content: center;\n  }\n\n  .slide-image {\n    width: 210px;\n    height: 195px;\n    border: 1px solid #CDCDCD;\n    border-radius: 10px;\n    position: relative;\n    @media (max-width: 490px) {\n      width: 100%;\n      height: auto;\n    }\n\n    img {\n      width: 210px;\n      height: 195px;\n      object-fit: cover;\n      padding: 20px;\n      @media (max-width: 490px) {\n        width: 100%;\n      }\n    }\n\n    button {\n      position: absolute;\n      top: 0px;\n      right: -5px;\n      border: none;\n      background: transparent;\n      cursor: pointer;\n    }\n  }\n}\n\n.image-frame {\n  max-width: 100%;\n  height: 90px;\n  border: 1px solid #CDCDCD;\n  border-radius: 10px;\n  position: relative;\n  @media (max-width: 400px) {\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .preview-img {\n    max-width: 100%;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    padding: 10px;\n    //@media (max-width: 400px) {\n    //  max-width: 100%;\n    //  width: 86%;\n    //}\n  }\n\n  .input-img {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 10px;\n\n    p {\n      color: #3963AD;\n      text-align: center;\n      font-size: 14px;\n      font-weight: 500;\n    }\n\n    input {\n      display: none;\n    }\n  }\n}\n\n.image-for-preview {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n  flex-direction: column;\n\n  .edit-images {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 15px;\n\n    .add-edit-images {\n      position: relative;\n\n\n      img {\n        width: 150px;\n        height: 120px;\n        object-fit: cover;\n        position: relative;\n      }\n\n      span {\n        position: absolute;\n        top: 0;\n        right: 0;\n        color: red;\n        cursor: pointer;\n      }\n\n    }\n\n  }\n\n}\n\n",".admin-navigation {\n  //height: 100vh;\n  background: #041737;\n  //padding: 15px;\n  position: relative;\n  cursor: pointer;\n  //transition: all ease-in-out .10s;\n  transition: width 0.3s ease-in-out;\n  \n  .admin-logo {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    transition: all ease-in-out .6s;\n\n    .logo {\n      width: 120px;\n\n    }\n\n    h5 {\n      color: #fff;\n      display: block;\n      margin-top: 15px;\n      font-family: $robotoFont;\n      font-size: 14px;\n      margin-bottom: 100px;\n\n    }\n  }\n\n\n  .admin-nav-link {\n    display: flex;\n    flex-direction: column;\n    margin: 0 20px;\n    gap: 15px;\n    transition: all ease-in-out .3s;\n\n    a {\n      color: #79A3D6;\n      font-size: 16px;\n      font-weight: 400;\n      text-transform: uppercase;\n      //line-height: 60px;\n      //padding-left: 30px;\n      display: flex;\n      align-items: center;\n      gap: 20px;\n      padding: 10px 15px;\n      transition: all ease-in-out .2s;\n\n      &:hover {\n        border-radius: 10px;\n        background: #3963AD;\n        color: #fff;\n      }\n\n      svg {\n        font-size: 30px;\n        //margin-right: 15px;\n        //margin-top: 2px;\n        //background: none;\n      }\n    }\n\n    .active {\n      border-radius: 10px;\n      background: #3963AD;\n      color: #fff;\n    }\n\n  }\n\n}\n\n.logOut {\n\n  border: none;\n  background: transparent;\n  color: #fff;\n  font-size: 25px;\n  text-transform: uppercase;\n  text-align: center;\n  width: 100%;\n  margin-top: 50px;\n  cursor: pointer;\n  padding: 10px 15px;\n  border-radius: 10px;\n  transition: all ease-in-out .3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n\n  &:hover {\n    background-color: rgba(255, 255, 255, .3);\n  }\n\n  svg {\n    font-size: 30px;\n  }\n}\n\n.admin-navigation {\n  width: 270px;\n  transition: all ease-in-out .2s;\n\n  .open-sidebar {\n    position: absolute;\n    right: -5px;\n    cursor: pointer;\n\n    svg {\n      color: #fff;\n      font-size: 40px;\n    }\n\n  }\n}\n\n\n.open {\n  width: 120px;\n  transition: all ease-in-out .2s;\n\n  .close-sidebar {\n    position: absolute;\n    right: -5px;\n    cursor: pointer;\n\n    svg {\n      color: #fff;\n      font-size: 40px;\n      text-align: center;\n    }\n\n  }\n\n  .admin-nav-link {\n    transition: all ease-in-out .2s;\n\n    a {\n      display: block;\n      text-align: center;\n      padding: 10px 0;\n    }\n  }\n}\n",".admin-body{\n    display: flex;\n    background: #F0F1F3;\n    width: 100%;\n    height: 100%;\n    position: relative;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
